<div class="containeer-fluid">
  <div class="row">
    <div class="col-lg-1 col-12 px-0">
      <div class="d-flex myside-menu-container">
        <div
          class="nav flex-lg-column nav-pills px-1"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <button
            (click)="goBack()"
            class="nav-link btn-link"
            type="button"
            role="tab"
          >
            <i class="bx bx-arrow-back fs-5 text-primary"></i>
          </button>

          <button
            class="nav-link active"
            id="usecase-list-tab"
            data-bs-toggle="pill"
            data-bs-target="#usecase-list"
            type="button"
            role="tab"
            aria-controls="usecase-list"
            aria-selected="false"
            (click)="activetab = 'usecase-list-tab'; getUsecaseDataList()"
          >
            <i
              class="fa fa-list"
              [matTooltip]="'USECASEDATABASE.LIST' | translate"
              matTooltipPosition="right"
            ></i>
          </button>

          <button
            *ngIf="showTable == true"
            class="nav-link btn-link"
            id="usecase-dashboard-tab"
            data-bs-toggle="pill"
            data-bs-target="#usecase-dashboard"
            type="button"
            role="tab"
            aria-controls="usecase-dashboard"
            aria-selected="false"
            (click)="
              activetab = 'usecase-dashboard-tab';
              checklocation();
              setDefaultvalue()
            "
          >
            <i
              class="bi bi-card-heading fs-5 p-0"
              [matTooltip]="'USECASEDATABASE.DATA_ENTRY' | translate"
              matTooltipPosition="right"
            ></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-11 col-12 ps-0 my-margin-left">
      <div class="tab-content" id="v-pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="usecase-list"
          role="tabpanel"
          aria-labelledby="usecase-list-tab"
        >
          <!-- list  -->
          <div class="container-fluid">
            <!-- Home -->
            <div class="row">
              <div class="col-md-12">
                <div
                  class="d-flex justify-content-between flex-wrap gap-2 align-item-center my-2"
                >
                  <div *ngIf="UserListT == false">
                    <h5 class="d-flex align-items-center mb-0">
                      <mat-icon class="text-primary">storage</mat-icon>
                      <p class="wrap-text mb-0 ms-2">
                        {{ usecaseSchema["name"] }}
                        {{ "USECASEDATABASE.DATABASE" | translate }}
                      </p>
                    </h5>
                  </div>

                  <div *ngIf="UserListT == true">
                    <h5 class="d-flex align-items-center mb-0">
                      <i class="fa fa-list text-primary"></i>
                      <p class="wrap-text mb-0 ms-2">
                        {{ usecaseSchema["name"] }}
                        {{ "USECASEDATABASE.DATABASE_USER" | translate }}
                      </p>
                    </h5>
                  </div>

                  <div>
                    <app-list-header [$parent]="getSelf()"></app-list-header>
                  </div>
                </div>
              </div>
              <div class="col col-md-12 mt-3">
                <div class="card">
                  <div class="card-body">
                    <div class="compact-inputs dropdown-pd-none">
                      <div
                        *ngIf="UserListT == false"
                        class="search-card-header gap-3 ps-0"
                      >
                        <button
                          mat-stroked-button
                          color="primary"
                          [disabled]="!form.searchParams['usecaseId']"
                          [title]="
                            (showSearchInputs
                              ? 'USECASEDATABASE.HIDE_SEARCH'
                              : 'USECASEDATABASE.SHOW_SEARCH'
                            ) | translate
                          "
                          (click)="toggleSearchInputs()"
                        >
                          <mat-icon>tune</mat-icon>
                          <span>{{
                            "APP_STORE.SEARCH.FILTER" | translate
                          }}</span>
                        </button>
                        <div *ngIf="UserListT == false">
                          <mat-form-field
                            appearance="outline"
                            class="compact-inputs"
                          >
                            <mat-select
                              [(ngModel)]="form.searchParams['usecaseId']"
                              (selectionChange)="onUsecaseSelect()"
                              name="usecaseId"
                              [placeholder]="
                                'USECASEDATABASE.USECASE_SELECT' | translate
                              "
                            >
                              <!-- Search input inside dropdown -->
                              <mat-option>
                                <ngx-mat-select-search
                                  #usecaseSearch
                                  [placeholderLabel]="'Search usecase...'"
                                  class="compact-search"
                                  noEntriesFoundLabel="No matches found"
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                              <!-- Filtered usecases with search functionality -->
                              <ng-container *ngFor="let e of filterUsecases()">
                                <mat-option
                                  *ngIf="
                                    !usecaseSearch.value ||
                                    e['name']
                                      .toLowerCase()
                                      .includes(
                                        usecaseSearch.value.toLowerCase()
                                      )
                                  "
                                  [value]="e['id']"
                                >
                                  {{ e["name"] }}
                                </mat-option>
                              </ng-container>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      <div>
                        <div class="search-panel" *ngIf="showSearchInputs">
                          <!-- Search Content -->
                          <div class="search-content mt-2">
                            <div class="row align-items-center">
                              <ng-container *ngFor="let e of attributeList">
                                <!-- REF KEY 1 (ng-select with search) -->
                                <div
                                  *ngIf="e['refKey'] == 1"
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-select
                                          [(ngModel)]="searchValues[e.code]"
                                          [compareWith]="compareFn"
                                          (selectionChange)="
                                            onSearchReferenceValueChange1(
                                              e,
                                              $event.value
                                            )
                                          "
                                        >
                                          <mat-option>
                                            <ngx-mat-select-search
                                              #searchVar
                                              [placeholderLabel]="
                                                'Search ' + e.label + '...'
                                              "
                                              noEntriesFoundLabel="No matches found"
                                            >
                                            </ngx-mat-select-search>
                                          </mat-option>
                                          <mat-option [value]="null"
                                            >-- None --</mat-option
                                          >
                                          <ng-container
                                            *ngFor="
                                              let item of getFilteredData(
                                                form.preload?.[
                                                  e.primaryUsecase
                                                ] || []
                                              )
                                            "
                                          >
                                            <mat-option
                                              *ngIf="
                                                filterFn(searchVar.value, item)
                                              "
                                              [value]="item.id"
                                            >
                                              {{ item._val }}
                                            </mat-option>
                                          </ng-container>
                                        </mat-select>
                                        <mat-label>{{ e.label }}</mat-label>
                                      </mat-form-field>
                                    </div>
                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>
                                <div
                                  *ngIf="e['type'] === 'date'"
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <input
                                          matInput
                                          type="date"
                                          #dateField
                                          [(ngModel)]="searchValues[e.code]"
                                          (change)="
                                            onValueChange(
                                              e,
                                              $any($event).target.value
                                            )
                                          "
                                          (click)="dateField.showPicker()"
                                          style="cursor: pointer"
                                        />

                                        <button
                                          mat-icon-button
                                          matSuffix
                                          type="button"
                                          (click)="dateField.showPicker()"
                                          class="icon-pd-none"
                                        >
                                          <mat-icon
                                            class="text-secondary icon-compact"
                                            >event</mat-icon
                                          >
                                        </button>
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>

                                <!-- For regular text/number inputs (excluding idate, itime, time) -->
                                <div
                                  *ngIf="
                                    e['refKey'] != 1 &&
                                    e['type'] !== 'list' &&
                                    e['type'] !== 'file' &&
                                    e['type'] !== 'doc' &&
                                    e['type'] !== 'map' &&
                                    e['type'] !== 'location' &&
                                    e['type'] !== 'boolean' &&
                                    e['type'] !== 'date' &&
                                    e['type'] !== 'idate' &&
                                    e['type'] !== 'itime' &&
                                    e['type'] !== 'time' &&
                                    e['type'] !== 'password' &&
                                    e['type'] !== 'dateandtime'
                                  "
                                  &&
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <input
                                          matInput
                                          [type]="getInputType(e.type)"
                                          [(ngModel)]="searchValues[e.code]"
                                          (ngModelChange)="
                                            onValueChange(e, $event)
                                          "
                                        />
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>

                                <!-- For idate type -->
                                <div
                                  *ngIf="
                                    e['refKey'] != 1 && e['type'] === 'idate'
                                  "
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <input
                                          matInput
                                          type="date"
                                          #idateInput
                                          [(ngModel)]="searchValues[e.code]"
                                          (ngModelChange)="
                                            onValueChange(e, $event)
                                          "
                                        />
                                        <button
                                          mat-icon-button
                                          matSuffix
                                          type="button"
                                          class="icon-pd-none"
                                          (click)="idateInput.showPicker()"
                                          aria-label="Open date picker"
                                        >
                                          <mat-icon
                                            class="icon-compact text-secondary"
                                            >event</mat-icon
                                          >
                                        </button>
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>

                                <!-- For itime type -->
                                <div
                                  *ngIf="
                                    e['refKey'] != 1 && e['type'] === 'itime'
                                  "
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <input
                                          matInput
                                          type="time"
                                          #itimeInput
                                          [(ngModel)]="searchValues[e.code]"
                                          (ngModelChange)="
                                            onValueChange(e, $event)
                                          "
                                        />
                                        <button
                                          mat-icon-button
                                          matSuffix
                                          type="button"
                                          class="icon-pd-none"
                                          (click)="itimeInput.showPicker()"
                                          aria-label="Open time picker"
                                        >
                                          <mat-icon
                                            class="icon-compact text-secondary"
                                            >schedule</mat-icon
                                          >
                                        </button>
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>

                                <!-- For time type -->
                                <div
                                  *ngIf="
                                    e['refKey'] != 1 && e['type'] === 'time'
                                  "
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <input
                                          matInput
                                          type="time"
                                          #timeInput
                                          [(ngModel)]="searchValues[e.code]"
                                          (ngModelChange)="
                                            onValueChange(e, $event)
                                          "
                                        />
                                        <button
                                          mat-icon-button
                                          matSuffix
                                          type="button"
                                          class="icon-pd-none"
                                          (click)="timeInput.showPicker()"
                                          aria-label="Open time picker"
                                        >
                                          <mat-icon
                                            class="icon-compact text-secondary"
                                            >schedule</mat-icon
                                          >
                                        </button>
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>

                                <!-- For date+time combined type (datetime-local) -->
                                <div
                                  *ngIf="
                                    e['refKey'] != 1 &&
                                    e['type'] === 'dateandtime'
                                  "
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <input
                                          matInput
                                          type="datetime-local"
                                          #datetimeInput
                                          [(ngModel)]="searchValues[e.code]"
                                          (ngModelChange)="
                                            onValueChange(e, $event)
                                          "
                                        />
                                        <button
                                          mat-icon-button
                                          matSuffix
                                          type="button"
                                          class="icon-pd-none"
                                          (click)="datetimeInput.showPicker()"
                                          aria-label="Open date and time picker"
                                        >
                                          <mat-icon
                                            class="icon-compact text-secondary"
                                            >calendar_month</mat-icon
                                          >
                                        </button>
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>

                                <!-- For password type - using single showPassword variable -->
                                <div
                                  *ngIf="
                                    e['refKey'] != 1 && e['type'] === 'password'
                                  "
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <input
                                          matInput
                                          [type]="
                                            showPassword ? 'text' : 'password'
                                          "
                                          [(ngModel)]="searchValues[e.code]"
                                          (ngModelChange)="
                                            onValueChange(e, $event)
                                          "
                                        />
                                        <button
                                          mat-icon-button
                                          matSuffix
                                          type="button"
                                          class="icon-pd-none"
                                          (click)="togglePasswordVisibility()"
                                          aria-label="Toggle password visibility"
                                        >
                                          <mat-icon
                                            class="icon-compact text-secondary"
                                            style="font-size: 8px"
                                          >
                                            <span class="pe-2">{{
                                              showPassword
                                                ? "visibility_off"
                                                : "visibility"
                                            }}</span>
                                          </mat-icon>
                                        </button>
                                      </mat-form-field>
                                    </div>
                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>

                                <!-- LIST DROPDOWN with Search -->
                                <div
                                  *ngIf="e['type'] === 'list'"
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-select
                                          [(ngModel)]="searchValues[e.code]"
                                        >
                                          <mat-option>
                                            <ngx-mat-select-search
                                              #dynamicSearch
                                              [placeholderLabel]="
                                                'Search ' + e.label + '...'
                                              "
                                              noEntriesFoundLabel="No matches found"
                                            >
                                            </ngx-mat-select-search>
                                          </mat-option>

                                          <mat-option [value]="null"
                                            >-- None --</mat-option
                                          >

                                          <ng-container
                                            *ngFor="let item of e['values']"
                                          >
                                            <mat-option
                                              *ngIf="
                                                !dynamicSearch.value ||
                                                (item?.self
                                                  ? item.self
                                                      .toLowerCase()
                                                      .includes(
                                                        dynamicSearch.value.toLowerCase()
                                                      )
                                                  : item
                                                      ?.toString()
                                                      .toLowerCase()
                                                      .includes(
                                                        dynamicSearch.value.toLowerCase()
                                                      ))
                                              "
                                              [value]="
                                                item?.self ? item.self : item
                                              "
                                            >
                                              {{
                                                item?.self ? item.self : item
                                              }}
                                            </mat-option>
                                          </ng-container>
                                        </mat-select>
                                        <mat-label>{{ e.label }}</mat-label>
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>
                                <!-- BOOLEAN DROPDOWN -->
                                <div
                                  *ngIf="e['type'] === 'boolean'"
                                  class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2"
                                >
                                  <div
                                    class="d-flex justify-content-start align-items-center"
                                  >
                                    <div class="flex-grow-1">
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                      >
                                        <mat-label>{{ e.label }}</mat-label>
                                        <mat-select
                                          [(ngModel)]="searchValues[e.code]"
                                        >
                                          <mat-option [value]="undefined">
                                            {{
                                              "UsecaseData.USECASE.LIST.BOOLEAN_SELECT"
                                                | translate
                                            }}
                                          </mat-option>
                                          <mat-option [value]="1">
                                            {{
                                              "UsecaseData.USECASE.LIST.TRUE"
                                                | translate
                                            }}
                                          </mat-option>
                                          <mat-option [value]="0">
                                            {{
                                              "UsecaseData.USECASE.LIST.FALSE"
                                                | translate
                                            }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </div>

                                    <button
                                      mat-icon-button
                                      class="icon-center icon-clean ms-1"
                                      [matTooltip]="getDescription(e)"
                                    >
                                      <mat-icon
                                        class="text-secondary icon-compact"
                                        >info</mat-icon
                                      >
                                    </button>
                                  </div>
                                </div>
                              </ng-container>
                              <!-- SEARCH + RESET BUTTONS -->
                              <div
                                class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2 d-flex align-items-center"
                              >
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  (click)="getUsecaseDataList()"
                                  class="me-2"
                                >
                                  <mat-icon>search</mat-icon>
                                  <span>{{
                                    "UsecaseData.USECASE.LIST.ACTIONS.SEARCH"
                                      | translate
                                  }}</span>
                                </button>

                                <button
                                  mat-stroked-button
                                  color="warn"
                                  (click)="resetSearch()"
                                >
                                  <i class="fa fa-eraser"></i>
                                  <span class="ms-2">{{
                                    "UsecaseData.USECASE.LIST.ACTIONS.RESET"
                                      | translate
                                  }}</span>
                                </button>
                              </div>
                            </div>
                            <!-- Shared Datepicker -->
                            <mat-datepicker #picker></mat-datepicker>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div *ngIf="showTable == true">
                            <p
                              *ngIf="form['error'] == false && form['message']"
                            >
                              <app-ncs-alert
                                [message]="form['message']"
                                type="success"
                              />
                            </p>
                            <p *ngIf="form['error'] == true && form['message']">
                              <app-ncs-alert
                                [message]="form['message']"
                                type="danger"
                              />
                            </p>

                            <div class="d-flex mb-4 action-toolbar">
                              <div
                                class="d-flex order-actions flex-wrap gap-2 align-items-center"
                              >
                                <!-- Excel Export -->
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="
                                    'USECASEDATABASE.EXCEL' | translate
                                  "
                                  (click)="exportData()"
                                >
                                  <mat-icon class="me-1">download</mat-icon>
                                  <span>{{
                                    "USECASEDATABASE.EXCEL" | translate
                                  }}</span>
                                </button>
                                <!-- PDF Export -->
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="'PDF' | translate"
                                  (click)="exportPDFDataEmail()"
                                >
                                  <mat-icon class="me-1"
                                    >picture_as_pdf</mat-icon
                                  >
                                  <span>{{
                                    "USECASEDATABASE.PDF" | translate
                                  }}</span>
                                </button>
                                <!-- Upload CSV -->
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="
                                    'USECASEDATABASE.UPLOAD' | translate
                                  "
                                  (click)="csvfileInput.click()"
                                >
                                  <mat-icon class="me-1">upload</mat-icon>
                                  <span>{{
                                    "USECASEDATABASE.UPLOAD" | translate
                                  }}</span>
                                </button>
                                <!-- Hidden file input -->
                                <input
                                  type="file"
                                  #csvfileInput
                                  class="d-none"
                                  accept="csv"
                                  (change)="onCsvFileUpload($event)"
                                />
                                <!-- Sample CSV Download -->
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="
                                    'USECASEDATABASE.SAMPLE_CSV' | translate
                                  "
                                  (click)="exportSampleData()"
                                >
                                  <mat-icon class="me-1"
                                    >file_download</mat-icon
                                  >
                                  <span>{{
                                    "USECASEDATABASE.SAMPLE_CSV" | translate
                                  }}</span>
                                </button>

                                <!-- Upload logs errors Button -->
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  matTooltipPosition="above"
                                  [routerLink]="['/upload-logs', usecaseId]"
                                  [matTooltip]="
                                    'BUTTONS.UPLOAD_ERROR_LOGS' | translate
                                  "
                                  class="d-flex align-items-center"
                                >
                                  <mat-icon class="me-1">history</mat-icon>
                                  {{ "BUTTONS.UPLOAD_ERROR_LOGS" | translate }}
                                </button>
                                <!-- Add New -->
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="'ADD' | translate"
                                  (click)="
                                    changeTab('usecase-dashboard-tab');
                                    resetImgDoc();
                                    setDefaultvalue()
                                  "
                                >
                                  <mat-icon class="me-1">add</mat-icon>
                                  <span>{{
                                    "USECASEDATABASE.ADD" | translate
                                  }}</span>
                                </button>
                                <!-- Delete All -->
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  [matTooltip]="
                                    'USECASEDATABASE.DELETE' | translate
                                  "
                                  (click)="Deleteall()"
                                >
                                  <mat-icon class="me-1 icon-compact"
                                    >delete</mat-icon
                                  >
                                  <span>{{
                                    "USECASEDATABASE.DELETE" | translate
                                  }}</span>
                                </button>
                                <!-- Archive/List Toggle -->
                                <div class="d-flex gap-2" role="tablist">
                                  <ng-container
                                    *ngIf="!isArchivedlistTabActive"
                                  >
                                    <button
                                      mat-stroked-button
                                      color="primary"
                                      id="pills-mainlist-tab"
                                      type="button"
                                      role="tab"
                                      (click)="toggleTab('archivedlist')"
                                    >
                                      <mat-icon class="me-1">archive</mat-icon>
                                      <span>{{
                                        "USECASEDATABASE.ARCHIVE" | translate
                                      }}</span>
                                    </button>
                                  </ng-container>
                                  <ng-container *ngIf="isArchivedlistTabActive">
                                    <button
                                      mat-stroked-button
                                      color="primary"
                                      id="pills-archivedlist-tab"
                                      type="button"
                                      role="tab"
                                      (click)="toggleTab('mainlist')"
                                    >
                                      <mat-icon class="me-1">list</mat-icon>
                                      <span>{{
                                        "USECASEDATABASE.LIST" | translate
                                      }}</span>
                                    </button>
                                  </ng-container>
                                  <!-- Trash -->
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    id="pills-trash-tab"
                                    type="button"
                                    role="tab"
                                    (click)="toggleTab('trashlist')"
                                  >
                                    <mat-icon class="me-1"
                                      >delete_outline</mat-icon
                                    >
                                    <span>{{
                                      "USECASEDATABASE.TRASH" | translate
                                    }}</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="tab-content" id="pills-tabContent">
                              <div
                                class="tab-pane fade"
                                [class.show]="
                                  !isArchivedlistTabActive && !isTrashTabActive
                                "
                                [class.active]="
                                  !isArchivedlistTabActive && !isTrashTabActive
                                "
                                id="pills-home"
                                role="tabpanel"
                                aria-labelledby="pills-home-tab"
                              >
                                <div class="table-container">
                                  <div
                                    class="table-responsive table-scrollable"
                                  >
                                    <table
                                      class="table table-bordered table-hover table-sticky-header"
                                    >
                                      <thead>
                                        <tr>
                                          <!-- Checkbox Column -->
                                          <th class="text-center">
                                            <mat-checkbox
                                              [(ngModel)]="masterSelected"
                                              (change)="selectAll()"
                                              color="primary"
                                            >
                                            </mat-checkbox>
                                          </th>

                                          <!-- Edit Column -->
                                          <th class="text-center">
                                            {{
                                              "USECASEDATABASE.EDIT" | translate
                                            }}
                                          </th>

                                          <!-- Serial Number Column -->
                                          <th class="text-center">
                                            {{
                                              "UsecaseData.USECASE.LIST.TABLE.SERIAL_NO"
                                                | translate
                                            }}
                                          </th>

                                          <!-- Dynamic Attribute Columns -->
                                          <th
                                            *ngFor="
                                              let e of attributeList;
                                              let i = index
                                            "
                                            (click)="sortTable(e.code)"
                                            class="sortable-header"
                                          >
                                            <div
                                              class="d-flex align-items-center justify-content-between"
                                            >
                                              <span>{{
                                                getFilterLable(e["label"])
                                              }}</span>
                                              <div class="sort-icons">
                                                <i
                                                  *ngIf="
                                                    sortedField === e.code &&
                                                    sortOrder === 'ASC'
                                                  "
                                                  class="fa fa-sort-up ms-1 text-dark"
                                                ></i>
                                                <i
                                                  *ngIf="
                                                    sortedField === e.code &&
                                                    sortOrder === 'DESC'
                                                  "
                                                  class="fa fa-sort-down ms-1 text-dark"
                                                ></i>
                                                <i
                                                  *ngIf="sortedField !== e.code"
                                                  class="fa fa-sort ms-1 text-muted"
                                                ></i>
                                              </div>
                                            </div>
                                          </th>

                                          <!-- Tag Column Header -->
                                          <th *ngIf="enabletag === 1">
                                            {{ "COMMON.TAGS" | translate }}
                                          </th>

                                          <!-- Actions Column -->
                                          <th>
                                            {{
                                              "USECASEDATABASE.ACTION"
                                                | translate
                                            }}
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let e of filteredData;
                                            let i = index
                                          "
                                        >
                                          <td
                                            class="text-center"
                                            [ngStyle]="{
                                              'min-width':
                                                filteredData.length > 5
                                                  ? '50px'
                                                  : '0px',
                                            }"
                                          >
                                            <mat-checkbox
                                              [(ngModel)]="e.selected"
                                              color="primary"
                                              (change)="checkIfAllSelected()"
                                            >
                                            </mat-checkbox>
                                          </td>
                                          <td
                                            class="text-center"
                                            [ngStyle]="{
                                              'min-width':
                                                filteredData.length > 5
                                                  ? '50px'
                                                  : '0px',
                                            }"
                                          >
                                            <div
                                              class="d-flex align-item-center justify-content-center"
                                            >
                                              <div>
                                                <button
                                                  mat-icon-button
                                                  color="primary"
                                                  class="icon-clean icon-width"
                                                  [matTooltip]="
                                                    'UsecaseData.USECASE.LIST.ACTIONS.EDIT'
                                                      | translate
                                                  "
                                                  *ngIf="
                                                    form.data.readOnly != 'true'
                                                  "
                                                  (click)="
                                                    getUsecaseData(e['id']);
                                                    changeTab(
                                                      'usecase-dashboard-tab'
                                                    )
                                                  "
                                                >
                                                  <mat-icon class="icon-compact"
                                                    >edit</mat-icon
                                                  >
                                                </button>
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            class="text-center"
                                            [ngStyle]="{
                                              'min-width':
                                                filteredData.length > 5
                                                  ? '50px'
                                                  : '0px',
                                            }"
                                          >
                                            {{ pageIndex(i) }}
                                          </td>
                                          <td
                                            *ngFor="
                                              let at of attributeList;
                                              let i = index
                                            "
                                          >
                                            <span
                                              *ngIf="
                                                at['type'] === 'object' &&
                                                at['type'] != 'file' &&
                                                at['type'] !== 'doc' &&
                                                at['type'] !== 'location'
                                              "
                                              >{{ e[at["code"]] | json }}
                                            </span>
                                            <span
                                              *ngIf="
                                                at['type'] != 'object' &&
                                                at['type'] != 'file' &&
                                                at['type'] !== 'doc' &&
                                                at['type'] != 'textarea' &&
                                                at['type'] != 'email' &&
                                                at['type'] != 'text' &&
                                                at['type'] !== 'boolean' &&
                                                at['type'] !== 'location' &&
                                                at['type'] != 'list' &&
                                                at['type'] != 'map' &&
                                                at['type'] != 'time' &&
                                                at['type'] != 'itime' &&
                                                at['type'] !== 'dateandtime' &&
                                                at['type'] != 'json' &&
                                                at['type'] !== 'number' &&
                                                at['type'] !== 'tag'
                                              "
                                              >{{
                                                getString(
                                                  e[at["code"]],
                                                  at["type"]
                                                )
                                              }}</span
                                            >
                                            <span
                                              *ngIf="
                                                at['type'] === 'dateandtime'
                                              "
                                            >
                                              {{
                                                at["depAttribute"]
                                                  ? getString(
                                                      e[at["depAttribute"]],
                                                      at["type"]
                                                    )
                                                  : getString(
                                                      e[at["code"]],
                                                      at["type"]
                                                    )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="at['type'] === 'boolean'"
                                            >
                                              {{
                                                e[at["code"]] === 1
                                                  ? ("UsecaseData.USECASE.LIST.TRUE"
                                                    | translate)
                                                  : e[at["code"]] === 0
                                                    ? ("UsecaseData.USECASE.LIST.FALSE"
                                                      | translate)
                                                    : ""
                                              }}
                                            </span>
                                            <span
                                              *ngIf="at['type'] === 'list'"
                                              [title]="e[at['code']]"
                                            >
                                              {{
                                                e[at["code"]] === null ||
                                                e[at["code"]] == undefined ||
                                                e[at["code"]] == "undefined"
                                                  ? ""
                                                  : e[at["code"]]
                                              }}
                                            </span>
                                            <span *ngIf="at['type'] === 'map'">
                                              {{
                                                e[at["code"]] === null ||
                                                e[at["code"]] === undefined ||
                                                e[at["code"]] === "undefined"
                                                  ? ""
                                                  : e[at["code"]]
                                              }}
                                            </span>

                                            <span
                                              *ngIf="at['type'] === 'location'"
                                            >
                                              <ng-container
                                                *ngIf="
                                                  getLocationObject(
                                                    at['depAttribute']
                                                      ? e[at['depAttribute']]
                                                      : e[at['code']]
                                                  ) as loc
                                                "
                                              >
                                                <a
                                                  [href]="
                                                    'https://www.google.com/maps?q=' +
                                                    loc.lat +
                                                    ',' +
                                                    loc.lng
                                                  "
                                                  target="_blank"
                                                  style="text-decoration: none"
                                                  >{{ loc.lat }},{{ loc.lng }}
                                                </a>
                                              </ng-container>
                                            </span>
                                            <span
                                              *ngIf="
                                                at['type'] != 'list' &&
                                                at['type'] != 'object' &&
                                                at['type'] !== 'location' &&
                                                at['type'] === 'file' &&
                                                at['type'] !== 'tag'
                                              "
                                            >
                                              <a
                                                href="{{
                                                  getAppDoc(e[at['code']])
                                                }}"
                                                target="_blank"
                                              >
                                                <img
                                                  src="{{
                                                    getAppDocThumbnail(
                                                      e[at['code']]
                                                    )
                                                  }}"
                                                  width="50px"
                                                />
                                              </a>
                                            </span>

                                            <div
                                              *ngIf="at['type'] === 'textarea'"
                                              class="custom-textarea"
                                              [innerHTML]="
                                                getSanitizedHtml(e[at['code']])
                                              "
                                            ></div>

                                            <!--Json -->
                                            <div
                                              *ngIf="at['type'] === 'json'"
                                              class="custom-textarea"
                                              [innerHTML]="
                                                getSanitizedHtml(e[at['code']])
                                              "
                                            ></div>

                                            <span
                                              *ngIf="at['type'] === 'email'"
                                            >
                                              <a
                                                href="mailto:{{
                                                  e[at['code']]
                                                }}"
                                                target="_blank"
                                              >
                                                {{ e[at["code"]] }}
                                              </a>
                                            </span>
                                            <!-- Text / Number with QR/Barcode Support -->
                                            <span
                                              *ngIf="
                                                at['type'] === 'text' ||
                                                at['type'] === 'number'
                                              "
                                              class="d-block"
                                            >
                                              <!-- QR Code -->
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'qr' &&
                                                  e[at['code']]
                                                "
                                              >
                                                <a
                                                  href="javascript:void(0)"
                                                  [title]="e[at['code']]"
                                                  (click)="
                                                    openCodeInNewTab(
                                                      'qr',
                                                      e[at['code']].toString()
                                                    )
                                                  "
                                                  class="code-link text-decoration-none"
                                                >
                                                  <div
                                                    class="d-flex flex-column align-items-center"
                                                  >
                                                    <qrcode
                                                      [qrdata]="
                                                        e[at['code']].toString()
                                                      "
                                                      [width]="50"
                                                      [errorCorrectionLevel]="
                                                        'M'
                                                      "
                                                    ></qrcode>
                                                    <div
                                                      class="text-center mt-1"
                                                      style="
                                                        font-size: 11px;
                                                        color: #2e2e2e;
                                                      "
                                                    >
                                                      {{
                                                        e[at["code"]]
                                                          | truncate: 10
                                                      }}
                                                    </div>
                                                  </div>
                                                </a>
                                              </ng-container>

                                              <!-- Barcode -->
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'bar' &&
                                                  e[at['code']]
                                                "
                                              >
                                                <a
                                                  href="javascript:void(0)"
                                                  [title]="e[at['code']]"
                                                  (click)="
                                                    openCodeInNewTab(
                                                      'bar',
                                                      e[at['code']].toString()
                                                    )
                                                  "
                                                  class="code-link text-decoration-none"
                                                >
                                                  <div
                                                    class="d-flex flex-column align-items-center"
                                                  >
                                                    <ngx-barcode6
                                                      [bc-value]="
                                                        e[at['code']].toString()
                                                      "
                                                      bc-format="CODE128"
                                                      [bc-display-value]="false"
                                                      [bc-width]="0.8"
                                                      [bc-height]="20"
                                                    ></ngx-barcode6>
                                                    <div
                                                      class="text-center mt-1"
                                                      style="
                                                        font-size: 11px;
                                                        color: #363636;
                                                      "
                                                    >
                                                      {{
                                                        e[at["code"]]
                                                          | truncate: 10
                                                      }}
                                                    </div>
                                                  </div>
                                                </a>
                                              </ng-container>

                                              <!-- Plain Text (no code) — left aligned -->
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'none' ||
                                                  !at['codeType'] ||
                                                  !e[at['code']]
                                                "
                                              >
                                                <span
                                                  class="text-start d-block"
                                                  [title]="e[at['code']]"
                                                  >{{
                                                    e[at["code"]] | truncate: 40
                                                  }}</span
                                                >
                                              </ng-container>
                                            </span>

                                            <span *ngIf="at['type'] === 'time'">
                                              {{
                                                at["depAttribute"]
                                                  ? getString1(
                                                      e[at["depAttribute"]],
                                                      at["type"],
                                                      at["timeFormat"]
                                                    )
                                                  : getString1(
                                                      e[at["code"]],
                                                      at["type"],
                                                      at["timeFormat"]
                                                    )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="at['type'] === 'itime'"
                                            >
                                              {{
                                                at["depAttribute"]
                                                  ? getStringitime(
                                                      e[at["depAttribute"]],
                                                      at["type"],
                                                      at["itimeFormat"]
                                                    )
                                                  : getStringitime(
                                                      e[at["code"]],
                                                      at["type"],
                                                      at["itimeFormat"]
                                                    )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="
                                                at['type'] != 'list' &&
                                                at['type'] != 'object' &&
                                                at['type'] !== 'file' &&
                                                at['type'] !== 'location' &&
                                                at['type'] === 'doc' &&
                                                at['type'] !== 'tag'
                                              "
                                            >
                                              <a
                                                href="{{
                                                  getAppDoc(e[at['code']])
                                                }}"
                                                target="_blank"
                                              >
                                                <img
                                                  src="{{
                                                    getAppDocThumbnail(
                                                      e[at['code']]
                                                    )
                                                  }}"
                                                  width="50px"
                                                />
                                              </a>
                                            </span>
                                          </td>

                                          <td *ngIf="enabletag === 1">
                                            <span
                                              class="d-flex align-items-start gap-2"
                                            >
                                              <button
                                                type="button"
                                                class="btn btn-light btn-sm overflow-hidden text-truncate"
                                                data-bs-toggle="modal"
                                                data-bs-target="#tagsModal"
                                                (click)="allAttribute(e, i)"
                                                [title]="getFullTag(e['tag'])"
                                              >
                                                <ng-container
                                                  *ngIf="
                                                    getCleanTag(e['tag']) !==
                                                      'Add Tags';
                                                    else showTagIcon
                                                  "
                                                >
                                                  {{ getCleanTag(e["tag"]) }}
                                                </ng-container>
                                                <ng-template #showTagIcon>
                                                  <i
                                                    class="bi bi-tag tags-icon"
                                                  ></i>
                                                </ng-template>
                                              </button>
                                            </span>
                                          </td>

                                          <td>
                                            <div
                                              class="d-flex align-items-center"
                                            >
                                              <button
                                                mat-stroked-button
                                                color="primary"
                                                class="icon-center icon-clean icon-width ms-1 me-2"
                                                [matTooltip]="
                                                  'UsecaseData.USECASE.LIST.ACTIONS.INFO'
                                                    | translate
                                                "
                                                (click)="openInfoModal(e)"
                                              >
                                                <mat-icon class="icon-compact"
                                                  >info</mat-icon
                                                >
                                              </button>
                                              <button
                                                mat-stroked-button
                                                color="warn"
                                                class="icon-center icon-clean icon-width ms-1"
                                                [matTooltip]="
                                                  'UsecaseData.USECASE.LIST.ACTIONS.DELETE'
                                                    | translate
                                                "
                                                (click)="
                                                  deleteUsecaseData(e['id'])
                                                "
                                              >
                                                <mat-icon class="icon-compact"
                                                  >delete</mat-icon
                                                >
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="tab-pane fade"
                                [class.show]="
                                  isArchivedlistTabActive && !isTrashTabActive
                                "
                                [class.active]="
                                  isArchivedlistTabActive && !isTrashTabActive
                                "
                                id="pills-profile"
                                role="tabpanel"
                                aria-labelledby="pills-profile-tab"
                              >
                                <div class="table-container">
                                  <div
                                    class="table-responsive table-scrollable"
                                  >
                                    <table
                                      class="table table-bordered table-hover table-sticky-header"
                                    >
                                      <thead>
                                        <tr>
                                          <th class="text-center">S No</th>
                                          <th
                                            *ngFor="
                                              let e of attributeList;
                                              let i = index
                                            "
                                            (click)="sortTable(e.code)"
                                          >
                                            {{ getFilterLable(e["label"]) }}
                                            <i
                                              *ngIf="
                                                sortedField === e.code &&
                                                sortOrder === 'ASC'
                                              "
                                              class="fa fa-sort-up ms-1"
                                            ></i>
                                            <i
                                              *ngIf="
                                                sortedField === e.code &&
                                                sortOrder === 'DESC'
                                              "
                                              class="fa fa-sort-down ms-1"
                                            ></i>
                                            <i
                                              *ngIf="sortedField !== e.code"
                                              class="fa fa-sort ms-1"
                                            ></i>
                                          </th>
                                          <th>
                                            {{
                                              "USECASEDATABASE.ACTION"
                                                | translate
                                            }}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let e of form.archivedlist;
                                            let i = index
                                          "
                                        >
                                          <td class="text-center">
                                            {{ pageIndex(i) }}
                                          </td>
                                          <td
                                            class="text-wrap"
                                            *ngFor="
                                              let at of attributeList;
                                              let i = index
                                            "
                                          >
                                            <span
                                              *ngIf="
                                                at['type'] === 'object' &&
                                                at['type'] != 'file' &&
                                                at['type'] !== 'doc' &&
                                                at['type'] !== 'location'
                                              "
                                            >
                                              {{ e[at["code"]] | json }}
                                            </span>

                                            <!-- getString se text aur number exclude karo -->
                                            <span
                                              *ngIf="
                                                at['type'] != 'object' &&
                                                at['type'] != 'file' &&
                                                at['type'] !== 'doc' &&
                                                at['type'] !== 'location' &&
                                                at['type'] !== 'textarea' &&
                                                at['type'] != 'time' &&
                                                at['type'] != 'itime' &&
                                                at['type'] !== 'text' &&
                                                at['type'] !== 'number'
                                              "
                                            >
                                              {{
                                                getString(
                                                  e[at["code"]],
                                                  at["type"]
                                                )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="
                                                at['type'] != 'list' &&
                                                at['type'] != 'object' &&
                                                at['type'] !== 'location' &&
                                                at['type'] === 'file'
                                              "
                                            >
                                              <a
                                                href="{{
                                                  getAppDoc(e[at['code']])
                                                }}"
                                                target="_blank"
                                              >
                                                <img
                                                  src="{{
                                                    getAppDocThumbnail(
                                                      e[at['code']]
                                                    )
                                                  }}"
                                                  width="50px"
                                                />
                                              </a>
                                            </span>

                                            <div
                                              *ngIf="at['type'] === 'textarea'"
                                              class="custom-textarea"
                                              [innerHTML]="
                                                getSanitizedHtml(e[at['code']])
                                              "
                                            ></div>

                                            <span *ngIf="at['type'] === 'time'">
                                              {{
                                                at["depAttribute"]
                                                  ? getString1(
                                                      e[at["depAttribute"]],
                                                      at["type"],
                                                      at["timeFormat"]
                                                    )
                                                  : getString1(
                                                      e[at["code"]],
                                                      at["type"],
                                                      at["timeFormat"]
                                                    )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="at['type'] === 'itime'"
                                            >
                                              {{
                                                at["depAttribute"]
                                                  ? getStringitime(
                                                      e[at["depAttribute"]],
                                                      at["type"],
                                                      at["itimeFormat"]
                                                    )
                                                  : getStringitime(
                                                      e[at["code"]],
                                                      at["type"],
                                                      at["itimeFormat"]
                                                    )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="at['type'] === 'location'"
                                            >
                                              <ng-container
                                                *ngIf="
                                                  getLocationObject(
                                                    at['depAttribute']
                                                      ? e[at['depAttribute']]
                                                      : e[at['code']]
                                                  ) as loc
                                                "
                                              >
                                                <a
                                                  [href]="
                                                    'https://www.google.com/maps?q=' +
                                                    loc.lat +
                                                    ',' +
                                                    loc.lng
                                                  "
                                                  target="_blank"
                                                  style="text-decoration: none"
                                                >
                                                  {{ loc.lat }},{{ loc.lng }}
                                                </a>
                                              </ng-container>
                                            </span>

                                            <!-- Text / Number with QR/Barcode Support — TD KE ANDAR -->
                                            <span
                                              *ngIf="
                                                at['type'] === 'text' ||
                                                at['type'] === 'number'
                                              "
                                              class="d-block"
                                            >
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'qr' &&
                                                  e[at['code']]
                                                "
                                              >
                                                <a
                                                  href="javascript:void(0)"
                                                  [title]="e[at['code']]"
                                                  (click)="
                                                    openCodeInNewTab(
                                                      'qr',
                                                      e[at['code']].toString()
                                                    )
                                                  "
                                                  class="code-link text-decoration-none"
                                                >
                                                  <div
                                                    class="d-flex flex-column align-items-center"
                                                  >
                                                    <qrcode
                                                      [qrdata]="
                                                        e[at['code']].toString()
                                                      "
                                                      [width]="50"
                                                      [errorCorrectionLevel]="
                                                        'M'
                                                      "
                                                    ></qrcode>
                                                    <div
                                                      class="text-center mt-1"
                                                      style="
                                                        font-size: 11px;
                                                        color: #2e2e2e;
                                                      "
                                                    >
                                                      {{
                                                        e[at["code"]]
                                                          | truncate: 10
                                                      }}
                                                    </div>
                                                  </div>
                                                </a>
                                              </ng-container>
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'bar' &&
                                                  e[at['code']]
                                                "
                                              >
                                                <a
                                                  href="javascript:void(0)"
                                                  [title]="e[at['code']]"
                                                  (click)="
                                                    openCodeInNewTab(
                                                      'bar',
                                                      e[at['code']].toString()
                                                    )
                                                  "
                                                  class="code-link text-decoration-none"
                                                >
                                                  <div
                                                    class="d-flex flex-column align-items-center"
                                                  >
                                                    <ngx-barcode6
                                                      [bc-value]="
                                                        e[at['code']].toString()
                                                      "
                                                      bc-format="CODE128"
                                                      [bc-display-value]="false"
                                                      [bc-width]="0.8"
                                                      [bc-height]="20"
                                                    ></ngx-barcode6>
                                                    <div
                                                      class="text-center mt-1"
                                                      style="
                                                        font-size: 11px;
                                                        color: #363636;
                                                      "
                                                    >
                                                      {{
                                                        e[at["code"]]
                                                          | truncate: 10
                                                      }}
                                                    </div>
                                                  </div>
                                                </a>
                                              </ng-container>
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'none' ||
                                                  !at['codeType'] ||
                                                  !e[at['code']]
                                                "
                                              >
                                                <span
                                                  class="text-start d-block"
                                                  [title]="e[at['code']]"
                                                  >{{
                                                    e[at["code"]] | truncate: 40
                                                  }}</span
                                                >
                                              </ng-container>
                                            </span>
                                          </td>
                                          <!-- ← TD YAHAN BAND HOGI -->

                                          <td>
                                            <div class="d-flex">
                                              <button
                                                mat-stroked-button
                                                color="primary"
                                                class="icon-width"
                                                [title]="
                                                  'UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE'
                                                    | translate
                                                "
                                                (click)="retrieve(e['id'])"
                                              >
                                                <mat-icon>archive</mat-icon>
                                                <span class="ms-1">{{
                                                  "UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE"
                                                    | translate
                                                }}</span>
                                              </button>
                                              <button
                                                mat-stroked-button
                                                color="warn"
                                                class="ms-1 icon-width"
                                                [title]="
                                                  'UsecaseData.USECASE.LIST.ACTIONS.DELETE'
                                                    | translate
                                                "
                                                (click)="
                                                  deleteUsecaseData(e['id'])
                                                "
                                              >
                                                <mat-icon class="icon-compact"
                                                  >delete</mat-icon
                                                >
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="tab-pane fade"
                                [class.show]="isTrashTabActive"
                                [class.active]="isTrashTabActive"
                                id="pills-trash"
                                role="tabpanel"
                                aria-labelledby="pills-trash-tab"
                              >
                                <div class="table-container">
                                  <div
                                    class="table-responsive table-scrollable"
                                  >
                                    <table
                                      class="table table-bordered table-hover table-sticky-header"
                                    >
                                      <thead>
                                        <tr>
                                          <th>
                                            {{ "COMMON.SNO" | translate }}
                                          </th>
                                          <th
                                            *ngFor="
                                              let e of attributeList;
                                              let i = index
                                            "
                                            (click)="sortTable(e.code)"
                                          >
                                            {{ getFilterLable(e["label"]) }}
                                            <i
                                              *ngIf="
                                                sortedField === e.code &&
                                                sortOrder === 'ASC'
                                              "
                                              class="fa fa-sort-up ms-1"
                                            ></i>
                                            <i
                                              *ngIf="
                                                sortedField === e.code &&
                                                sortOrder === 'DESC'
                                              "
                                              class="fa fa-sort-down ms-1"
                                            ></i>
                                            <i
                                              *ngIf="sortedField !== e.code"
                                              class="fa fa-sort ms-1"
                                            ></i>
                                          </th>
                                          <th>
                                            {{
                                              "USECASEDATABASE.ACTION"
                                                | translate
                                            }}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let e of form.trashlist;
                                            let i = index
                                          "
                                        >
                                          <td class="text-center">
                                            {{ pageIndex(i) }}
                                          </td>
                                          <td
                                            class="text-wrap"
                                            *ngFor="
                                              let at of attributeList;
                                              let i = index
                                            "
                                          >
                                            <span
                                              *ngIf="
                                                at['type'] === 'object' &&
                                                at['type'] != 'file' &&
                                                at['type'] !== 'location'
                                              "
                                            >
                                              {{ e[at["code"]] | json }}
                                            </span>

                                            <span
                                              *ngIf="at['type'] === 'location'"
                                            >
                                              <ng-container
                                                *ngIf="
                                                  getLocationObject(
                                                    at['depAttribute']
                                                      ? e[at['depAttribute']]
                                                      : e[at['code']]
                                                  ) as loc
                                                "
                                              >
                                                <a
                                                  [href]="
                                                    'https://www.google.com/maps?q=' +
                                                    loc.lat +
                                                    ',' +
                                                    loc.lng
                                                  "
                                                  target="_blank"
                                                  style="text-decoration: none"
                                                >
                                                  {{ loc.lat }},{{ loc.lng }}
                                                </a>
                                              </ng-container>
                                            </span>

                                            <!-- text aur number exclude karo getString se -->
                                            <span
                                              *ngIf="
                                                at['type'] != 'object' &&
                                                at['type'] != 'file' &&
                                                at['type'] !== 'location' &&
                                                at['type'] != 'time' &&
                                                at['type'] != 'itime' &&
                                                at['type'] !== 'text' &&
                                                at['type'] !== 'number' &&
                                                at['type'] !== 'textarea'
                                              "
                                            >
                                              {{
                                                getString(
                                                  e[at["code"]],
                                                  at["type"]
                                                )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="
                                                at['type'] != 'list' &&
                                                at['type'] != 'object' &&
                                                at['type'] !== 'file' &&
                                                at['type'] === 'doc' &&
                                                at['type'] !== 'location'
                                              "
                                            >
                                              <a
                                                href="{{
                                                  getAppDoc(e[at['code']])
                                                }}"
                                                target="_blank"
                                              >
                                                <img
                                                  src="{{
                                                    getAppDocThumbnail(
                                                      e[at['code']]
                                                    )
                                                  }}"
                                                  width="50px"
                                                />
                                              </a>
                                            </span>

                                            <span *ngIf="at['type'] === 'time'">
                                              {{
                                                at["depAttribute"]
                                                  ? getString1(
                                                      e[at["depAttribute"]],
                                                      at["type"],
                                                      at["timeFormat"]
                                                    )
                                                  : getString1(
                                                      e[at["code"]],
                                                      at["type"],
                                                      at["timeFormat"]
                                                    )
                                              }}
                                            </span>

                                            <span
                                              *ngIf="at['type'] === 'itime'"
                                            >
                                              {{
                                                at["depAttribute"]
                                                  ? getStringitime(
                                                      e[at["depAttribute"]],
                                                      at["type"],
                                                      at["itimeFormat"]
                                                    )
                                                  : getStringitime(
                                                      e[at["code"]],
                                                      at["type"],
                                                      at["itimeFormat"]
                                                    )
                                              }}
                                            </span>

                                            <div
                                              *ngIf="at['type'] === 'textarea'"
                                              class="custom-textarea"
                                              [innerHTML]="
                                                getSanitizedHtml(e[at['code']])
                                              "
                                            ></div>

                                            <!-- Text / Number with QR/Barcode Support -->
                                            <span
                                              *ngIf="
                                                at['type'] === 'text' ||
                                                at['type'] === 'number'
                                              "
                                              class="d-block"
                                            >
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'qr' &&
                                                  e[at['code']]
                                                "
                                              >
                                                <a
                                                  href="javascript:void(0)"
                                                  [title]="e[at['code']]"
                                                  (click)="
                                                    openCodeInNewTab(
                                                      'qr',
                                                      e[at['code']].toString()
                                                    )
                                                  "
                                                  class="code-link text-decoration-none"
                                                >
                                                  <div
                                                    class="d-flex flex-column align-items-center"
                                                  >
                                                    <qrcode
                                                      [qrdata]="
                                                        e[at['code']].toString()
                                                      "
                                                      [width]="50"
                                                      [errorCorrectionLevel]="
                                                        'M'
                                                      "
                                                    ></qrcode>
                                                    <div
                                                      class="text-center mt-1"
                                                      style="
                                                        font-size: 11px;
                                                        color: #2e2e2e;
                                                      "
                                                    >
                                                      {{
                                                        e[at["code"]]
                                                          | truncate: 10
                                                      }}
                                                    </div>
                                                  </div>
                                                </a>
                                              </ng-container>
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'bar' &&
                                                  e[at['code']]
                                                "
                                              >
                                                <a
                                                  href="javascript:void(0)"
                                                  [title]="e[at['code']]"
                                                  (click)="
                                                    openCodeInNewTab(
                                                      'bar',
                                                      e[at['code']].toString()
                                                    )
                                                  "
                                                  class="code-link text-decoration-none"
                                                >
                                                  <div
                                                    class="d-flex flex-column align-items-center"
                                                  >
                                                    <ngx-barcode6
                                                      [bc-value]="
                                                        e[at['code']].toString()
                                                      "
                                                      bc-format="CODE128"
                                                      [bc-display-value]="false"
                                                      [bc-width]="0.8"
                                                      [bc-height]="20"
                                                    ></ngx-barcode6>
                                                    <div
                                                      class="text-center mt-1"
                                                      style="
                                                        font-size: 11px;
                                                        color: #363636;
                                                      "
                                                    >
                                                      {{
                                                        e[at["code"]]
                                                          | truncate: 10
                                                      }}
                                                    </div>
                                                  </div>
                                                </a>
                                              </ng-container>
                                              <ng-container
                                                *ngIf="
                                                  at['codeType'] === 'none' ||
                                                  !at['codeType'] ||
                                                  !e[at['code']]
                                                "
                                              >
                                                <span
                                                  class="text-start d-block"
                                                  [title]="e[at['code']]"
                                                  >{{
                                                    e[at["code"]] | truncate: 40
                                                  }}</span
                                                >
                                              </ng-container>
                                            </span>
                                          </td>
                                          <!-- ← TD YAHAN BAND -->

                                          <td>
                                            <div class="d-flex">
                                              <button
                                                mat-stroked-button
                                                color="primary"
                                                class="icon-width"
                                                matTooltip="{{
                                                  'UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE'
                                                    | translate
                                                }}"
                                                (click)="retrieve(e['id'])"
                                              >
                                                <mat-icon>archive</mat-icon>
                                                {{
                                                  "UsecaseData.USECASE.LIST.ACTIONS.RETRIEVE"
                                                    | translate
                                                }}
                                              </button>
                                              <button
                                                mat-stroked-button
                                                color="warn"
                                                class="ms-1 icon-width"
                                                matTooltip="{{
                                                  'UsecaseData.USECASE.LIST.ACTIONS.DELETE'
                                                    | translate
                                                }}"
                                                (click)="
                                                  deleteUsecaseData(e['id'])
                                                "
                                              >
                                                <mat-icon>delete</mat-icon>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <app-list-header
                              [$parent]="getSelf()"
                            ></app-list-header>
                          </div>
                          <div
                            *ngIf="UserListT == true"
                            class="row g-2 align-items-center"
                          >
                            <div
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{
                                      "applicationUsers.search.placeholder"
                                        | translate
                                    }}</mat-label>
                                    <input
                                      matInput
                                      type="text"
                                      [(ngModel)]="searchText"
                                    />
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="
                                    'applicationUsers.search.placeholder'
                                      | translate
                                  "
                                  matTooltipPosition="above"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- Search Input - Login -->
                            <div
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{
                                      "ALLREMAININGS.Enter_LOGin_Code"
                                        | translate
                                    }}</mat-label>
                                    <input
                                      matInput
                                      type="text"
                                      [(ngModel)]="searchLogicCode"
                                    />
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="
                                    'ALLREMAININGS.Enter_LOGin_Code' | translate
                                  "
                                  matTooltipPosition="above"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- Search Input - Mobile -->
                            <div
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12"
                            >
                              <div
                                class="d-flex justify-content-start align-items-center"
                              >
                                <div class="flex-grow-1">
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                  >
                                    <mat-label>{{
                                      "ALLREMAININGS.Enter_Mobile_id"
                                        | translate
                                    }}</mat-label>
                                    <input
                                      matInput
                                      type="number"
                                      [(ngModel)]="searchMobile"
                                    />
                                  </mat-form-field>
                                </div>
                                <button
                                  mat-icon-button
                                  class="icon-center icon-clean ms-1"
                                  [matTooltip]="
                                    'ALLREMAININGS.Enter_Mobile_id' | translate
                                  "
                                  matTooltipPosition="above"
                                >
                                  <mat-icon class="text-secondary icon-compact"
                                    >info</mat-icon
                                  >
                                </button>
                              </div>
                            </div>

                            <!-- Search Button -->
                            <div
                              class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12"
                            >
                              <div classs="d-flex align-items-center">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  class="me-3"
                                  (click)="searchUsers()"
                                >
                                  <mat-icon>search</mat-icon>
                                  <span>{{
                                    "applicationUsers.search.buttons.search"
                                      | translate
                                  }}</span>
                                </button>
                                <button
                                  mat-stroked-button
                                  color="warn"
                                  (click)="resetFilters()"
                                >
                                  <i class="fa fa-eraser eraser-warn-dark"></i>
                                  <span class="ms-2">{{
                                    "applicationUsers.search.buttons.reset"
                                      | translate
                                  }}</span>
                                </button>
                              </div>
                            </div>
                            <!-- Table -->
                            <div class="mt-3 pt-1">
                              <div class="table-container">
                                <div class="table-responsive table-scrollable">
                                  <table
                                    class="table table-bordered table-hover table-sticky-header"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          class="text-center"
                                          style="width: 5%"
                                        >
                                          {{
                                            "applicationUsers.table.headers.sno"
                                              | translate
                                          }}
                                        </th>

                                        <th class="text-nowrap sortable-header">
                                          <span
                                            class="header-label"
                                            (click)="sortTable('loginId')"
                                          >
                                            {{
                                              "ALLREMAININGS.Login" | translate
                                            }}
                                            <ng-container
                                              *ngTemplateOutlet="
                                                sortIcons;
                                                context: { key: 'loginId' }
                                              "
                                            ></ng-container>
                                          </span>
                                        </th>

                                        <th class="text-nowrap sortable-header">
                                          <span
                                            class="header-label"
                                            (click)="sortTable('roleName')"
                                          >
                                            {{
                                              "applicationUsers.table.headers.role"
                                                | translate
                                            }}
                                            <ng-container
                                              *ngTemplateOutlet="
                                                sortIcons;
                                                context: { key: 'roleName' }
                                              "
                                            ></ng-container>
                                          </span>
                                        </th>

                                        <th class="text-nowrap sortable-header">
                                          <span
                                            class="header-label"
                                            (click)="sortTable('loginCode')"
                                          >
                                            {{
                                              "ALLREMAININGS.Login_Code"
                                                | translate
                                            }}
                                            <ng-container
                                              *ngTemplateOutlet="
                                                sortIcons;
                                                context: { key: 'loginCode' }
                                              "
                                            ></ng-container>
                                          </span>
                                        </th>

                                        <th class="text-nowrap sortable-header">
                                          <span
                                            class="header-label"
                                            (click)="sortTable('mobileId')"
                                          >
                                            {{
                                              "ALLREMAININGS.Mobile_Id"
                                                | translate
                                            }}
                                            <ng-container
                                              *ngTemplateOutlet="
                                                sortIcons;
                                                context: { key: 'mobileId' }
                                              "
                                            ></ng-container>
                                          </span>
                                        </th>
                                      </tr>

                                      <ng-template #sortIcons let-key="key">
                                        <i
                                          *ngIf="
                                            sortedField === key &&
                                            sortOrder === 'ASC'
                                          "
                                          class="fa fa-sort-up ms-1 text-dark"
                                        ></i>
                                        <i
                                          *ngIf="
                                            sortedField === key &&
                                            sortOrder === 'DESC'
                                          "
                                          class="fa fa-sort-down ms-1 text-dark"
                                        ></i>
                                        <i
                                          *ngIf="sortedField !== key"
                                          class="fa fa-sort ms-1 text-muted"
                                        ></i>
                                      </ng-template>
                                    </thead>

                                    <tbody>
                                      <tr
                                        *ngFor="
                                          let e of UserList;
                                          let i = index
                                        "
                                      >
                                        <td
                                          class="text-center"
                                          style="width: 5%"
                                        >
                                          {{ pageIndex(i) }}
                                        </td>
                                        <td>{{ e.loginId }}</td>
                                        <td>{{ e.roleName }}</td>
                                        <td>{{ e.loginCode }}</td>
                                        <td>{{ e.mobileId }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <!-- Pagination / Footer Component -->
                              <div class="mt-4">
                                <app-list-header
                                  [$parent]="getSelf()"
                                ></app-list-header>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade ps-2"
          id="usecase-dashboard"
          role="tabpanel"
          aria-labelledby="usecase-dashboard-tab"
        >
          <div class="col-12 mt-2 mb-3">
            <h5 class="d-flex">
              <i class="bi bi-card-heading fs-4 text-primary me-2"></i>
              <p class="wrap-text mb-0">
                {{ usecaseSchema["name"] }} >
                {{ "USECASEDATABASE.ENTRY" | translate }}
              </p>
            </h5>
          </div>
          <!-- form  -->
          <div class="card">
            <div class="card-header d-flex justify-content-between bg-white">
              <h5 class="modal-title">{{ usecaseSchema["name"] }}</h5>
              <span
                *ngIf="usecaseSchema['description']"
                [matTooltip]="usecaseSchema['description']"
                matTooltipPosition="above"
              >
                <mat-icon class="text-secondary">info</mat-icon>
              </span>
            </div>
            <div class="card-body">
              <p *ngIf="form['error'] == false && form['message']">
                <app-ncs-alert [message]="form['message']" type="success" />
              </p>
              <p *ngIf="form['error'] == true && form['message']">
                <app-ncs-alert [message]="form['message']" type="danger" />
              </p>
              <ng-container *ngIf="usecaseSchema?.unique">
                <ng-container *ngFor="let unique of usecaseSchema.unique">
                  <p
                    class="btn btn-danger"
                    *ngIf="
                      isArray(unique) && getInputError(unique.join('_')) != ''
                    "
                    (click)="clearUniqueMessage(unique.join('_'))"
                  >
                    {{ getInputError(unique.join("_")) }}
                    <i class="fa fa-times"></i>
                  </p>
                </ng-container>
              </ng-container>
              <!-- db form start -->
              <form
                class="compact-inputs dropdown-pd-none"
                #usecaseForm="ngForm"
              >
                <div *ngFor="let e of filterAttributes(); let i = index">
                  <!-- Labels for different field types with Material info icon -->
                  <label
                    class="form-label d-flex align-items-center"
                    *ngIf="
                      e['type'] !== 'file' &&
                      e['type'] !== 'location' &&
                      e['type'] !== 'doc' &&
                      e['type'] !== 'expression'
                    "
                  >
                    <span>{{ getFilterLable(e["label"]) }}</span>
                    <span *ngIf="e['required'] == 1" class="text-danger ms-1"
                      >*</span
                    >
                    <span *ngIf="e.showDescription !== 1" class="ms-2">
                      <mat-icon
                        matTooltip="{{ getDescription(e) }}"
                        class="text-secondary icon-compact topmove"
                      >
                        info
                      </mat-icon>
                    </span>
                    <p
                      *ngIf="e.showDescription === 1"
                      class="text-muted mb-0"
                      style="font-size: 0.875rem"
                    >
                      {{ getDescription(e) }}
                    </p>
                  </label>

                  <label
                    class="form-label d-flex align-items-center"
                    *ngIf="
                      e['type'] === 'file' &&
                      e['type'] !== 'doc' &&
                      e['type'] !== 'location'
                    "
                  >
                    <span>{{ getFilterLable(e["label"]) }}</span>
                    <span *ngIf="e['required'] == 1" class="text-danger ms-1"
                      >*</span
                    >
                    <span *ngIf="e.showDescription !== 1" class="ms-2">
                      <mat-icon
                        matTooltip="{{ getDescription(e) }}"
                        class="text-secondary icon-compact topmove"
                      >
                        info
                      </mat-icon>
                    </span>
                    <p
                      *ngIf="e.showDescription === 1"
                      class="text-muted mb-0"
                      style="font-size: 0.875rem"
                    >
                      {{ getDescription(e) }}
                    </p>
                  </label>

                  <label
                    class="form-label d-flex align-items-center"
                    *ngIf="
                      e['type'] !== 'file' &&
                      e['type'] === 'doc' &&
                      e['type'] !== 'location'
                    "
                  >
                    <span>{{ getFilterLable(e["label"]) }}</span>
                    <span *ngIf="e['required'] == 1" class="text-danger ms-1"
                      >*</span
                    >
                    <span *ngIf="e.showDescription !== 1" class="ms-2">
                      <mat-icon
                        matTooltip="{{ getDescription(e) }}"
                        class="text-secondary icon-compact topmove"
                      >
                        info
                      </mat-icon>
                    </span>
                    <p
                      *ngIf="e.showDescription === 1"
                      class="text-muted mb-0"
                      style="font-size: 0.875rem"
                    >
                      {{ getDescription(e) }}
                    </p>
                  </label>

                  <label
                    class="form-label d-flex align-items-center"
                    *ngIf="e['type'] === 'location'"
                  >
                    <span>{{ getFilterLable(e.label) }}</span>
                    <span *ngIf="e['required'] == 1" class="text-danger ms-1"
                      >*</span
                    >
                    <span *ngIf="e.showDescription !== 1" class="ms-2">
                      <mat-icon
                        matTooltip="{{ getDescription(e) }}"
                        class="text-secondary icon-compact topmove"
                      >
                        info
                      </mat-icon>
                    </span>
                    <p
                      *ngIf="e.showDescription === 1"
                      class="text-muted mb-0"
                      style="font-size: 0.875rem"
                    >
                      {{ getDescription(e) }}
                    </p>
                  </label>

                  <label
                    class="form-label d-flex align-items-center"
                    *ngIf="e['type'] === 'expression'"
                  >
                    <span>{{ getFilterLable(e.label) }}</span>
                    <span *ngIf="e['required'] == 1" class="text-danger ms-1"
                      >*</span
                    >
                    <span *ngIf="e.showDescription !== 1" class="ms-2">
                      <mat-icon
                        matTooltip="{{ getDescription(e) }}"
                        class="text-secondary icon-compact topmove"
                      >
                        info
                      </mat-icon>
                    </span>
                    <p
                      *ngIf="e.showDescription === 1"
                      class="text-muted mb-0"
                      style="font-size: 0.875rem"
                    >
                      {{ getDescription(e) }}
                    </p>
                  </label>

                  <!-- Expression Field -->
                  <div *ngIf="e['type'] === 'expression'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        required="{{ e['required'] == 1 }}"
                        disabled
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        [readonly]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                      />
                    </mat-form-field>
                  </div>

                  <!-- Regular Input Fields -->
                  <!-- <div
                    *ngIf="e['refKey']!=1 && e['type']!=='list'  && e['type']!=='file' && e['type']!=='map'  && e['type']!=='textarea'  && e['type']!=='doc' && e['type']!=='location' && e['type'] !== 'combobox' && e['type'] !== 'boolean' && e['type'] !=='expression'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput required="{{e['required']==1}}" [type]="getInputType(e.type)"
                        [(ngModel)]="form.data[e.code]" id="{{e.code}}" name="{{e.code}}"
                        [placeholder]="getFilterLable(e.label)"
                        (input)="restrictDecimalPlaces($event, e.label, e?.placeValue)"
                        (change)="enforceMaxDate($event, e.code , e.type)" />
                    </mat-form-field>
                  </div> -->
                  <!-- For regular inputs (excluding all date/time types and password) -->
                  <div
                    *ngIf="
                      e['refKey'] != 1 &&
                      e['type'] !== 'list' &&
                      e['type'] !== 'file' &&
                      e['type'] !== 'map' &&
                      e['type'] !== 'textarea' &&
                      e['type'] !== 'doc' &&
                      e['type'] !== 'location' &&
                      e['type'] !== 'combobox' &&
                      e['type'] !== 'boolean' &&
                      e['type'] !== 'expression' &&
                      e['type'] !== 'date' &&
                      e['type'] !== 'idate' &&
                      e['type'] !== 'time' &&
                      e['type'] !== 'itime' &&
                      e['type'] !== 'dateandtime' &&
                      e['type'] !== 'password' &&
                      e['type'] !== 'json'
                    "
                  >
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        required="{{ e['required'] == 1 }}"
                        [type]="getInputType(e.type)"
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        (input)="
                          restrictDecimalPlaces($event, e.label, e?.placeValue)
                        "
                        (change)="enforceMaxDate($event, e.code, e.type)"
                      />
                    </mat-form-field>
                  </div>

                  <mat-form-field
                    appearance="outline"
                    *ngIf="e['type'] === 'json'"
                    class="w-100"
                  >
                    <textarea
                      matInput
                      [(ngModel)]="form.data[e.code]"
                      [id]="e.code"
                      [name]="e.code"
                      rows="5"
                      class="font-monospace"
                      placeholder='{ "key": "value" }'
                    >
                    </textarea>
                  </mat-form-field>

                  <!-- For date type -->
                  <div *ngIf="e['refKey'] != 1 && e['type'] === 'date'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="date"
                        #dateInput
                        required="{{ e['required'] == 1 }}"
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        (change)="enforceMaxDate($event, e.code, e.type)"
                        [readonly]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                        [min]="e.type === 'date' ? e.minDate : null"
                        [max]="e.type === 'date' ? e.maxDate : null"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="dateInput.showPicker()"
                        aria-label="Open date picker"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >event</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- For idate type -->
                  <div *ngIf="e['refKey'] != 1 && e['type'] === 'idate'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="date"
                        #idateInput
                        required="{{ e['required'] == 1 }}"
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        (change)="enforceMaxDate($event, e.code, e.type)"
                        [readonly]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                        [min]="
                          e.type === 'idate'
                            ? convertIntoLocalDate(e.minDate)
                            : null
                        "
                        [max]="
                          e.type === 'idate'
                            ? convertIntoLocalDate(e.maxDate)
                            : null
                        "
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="idateInput.showPicker()"
                        aria-label="Open date picker"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >event</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- For time type -->
                  <div *ngIf="e['refKey'] != 1 && e['type'] === 'time'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="time"
                        #timeInput
                        required="{{ e['required'] == 1 }}"
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        (change)="enforceMaxDate($event, e.code, e.type)"
                        [readonly]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="timeInput.showPicker()"
                        aria-label="Open time picker"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >schedule</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- For itime type -->
                  <div *ngIf="e['refKey'] != 1 && e['type'] === 'itime'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="time"
                        #itimeInput
                        required="{{ e['required'] == 1 }}"
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        (change)="enforceMaxDate($event, e.code, e.type)"
                        [readonly]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="itimeInput.showPicker()"
                        aria-label="Open time picker"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >schedule</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- For dateandtime type -->
                  <div *ngIf="e['refKey'] != 1 && e['type'] === 'dateandtime'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        type="datetime-local"
                        #dateandtimeInput
                        required="{{ e['required'] == 1 }}"
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        (change)="enforceMaxDate($event, e.code, e.type)"
                        [readonly]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="dateandtimeInput.showPicker()"
                        aria-label="Open date and time picker"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >calendar_month</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- For password type -->
                  <div *ngIf="e['refKey'] != 1 && e['type'] === 'password'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [type]="showPassword ? 'text' : 'password'"
                        required="{{ e['required'] == 1 }}"
                        [(ngModel)]="form.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="showPassword = !showPassword"
                        aria-label="Toggle password visibility"
                      >
                        <mat-icon class="icon-compact text-secondary">
                          {{ showPassword ? "visibility" : "visibility_off" }}
                        </mat-icon>
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- Boolean Field -->
                  <!-- <div *ngIf="e['type'] === 'boolean'">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-select required="{{e['required']==1}}" [(ngModel)]="form.data[e.code]" id="{{e.code}}"
                        name="{{e.code}}" (change)="restrictDecimalPlaces($event, e.label, e?.placeValue)">
                        <mat-option [value]="undefined" disabled>{{getFilterLable(e.label)}}</mat-option>
                        <mat-option [value]=1>{{'USECASEDATABASE.TRUE' | translate}}</mat-option>
                        <mat-option [value]=0>{{'USECASEDATABASE.FALSE' | translate}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div> -->
                  <div *ngIf="e['type'] === 'boolean'">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-select
                        [ngModel]="
                          form.data[e.code] === undefined
                            ? ''
                            : form.data[e.code]
                        "
                        (ngModelChange)="
                          form.data[e.code] = $event === '' ? undefined : $event
                        "
                        [required]="e['required'] == 1"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        (change)="
                          restrictDecimalPlaces($event, e.label, e?.placeValue)
                        "
                      >
                        <!-- Hidden default option for label fix -->
                        <mat-option value="" style="display: none">
                          -- Select {{ getFilterLable(e.label) }} --
                        </mat-option>

                        <mat-option [value]="1">
                          {{ "USECASEDATABASE.TRUE" | translate }}
                        </mat-option>
                        <mat-option [value]="0">
                          {{ "USECASEDATABASE.FALSE" | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- Combobox Component -->
                  <app-combobox
                    *ngIf="e['type'] === 'combobox'"
                    [e]="e"
                    [entryData]="form.data[e.code]"
                    (valueChange)="form.data[e.code] = $event"
                    [readonly]="
                      e['readOnly'] ||
                      (e.allowChangeAfterInitial == 1 && form.data['id'] > 0)
                    "
                    [id]="form.data['id']"
                  >
                  </app-combobox>

                  <!-- <div *ngIf="e['refKey']==1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-select [(ngModel)]="form.data[e.code]"
                        [disabled]="e['readOnly'] || (e.allowChangeAfterInitial == 1 && form.data['id'] > 0)"
                        [required]="e['required'] == 1" (selectionChange)="onChange(e, $event)"
                        [compareWith]="compareFn" id="{{ e.code }}" name="{{ e.code }}">
                   
                        <mat-option>
                          <ngx-mat-select-search #searchRef [placeholderLabel]="'Search ' + e.label + '...'"
                            [noEntriesFoundLabel]="'No matches found'">
                          </ngx-mat-select-search>
                        </mat-option>
                      
                        <mat-option [value]="null" *ngIf="!e['required']">
                          -- {{'USECASEDATABASE.SELECT' | translate}} --
                        </mat-option>
                       
                        <ng-container *ngFor="let item of getFilteredData(form.preload?.[e.primaryUsecase] || [])">
                          <mat-option *ngIf="!searchRef.value || filterFn(searchRef.value, item)" [value]="item.id">
                            {{ item._val }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </div> -->

                  <div *ngIf="e['refKey'] == 1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-select
                        [ngModel]="
                          form.data[e.code] === undefined
                            ? ''
                            : form.data[e.code]
                        "
                        (ngModelChange)="
                          form.data[e.code] = $event === '' ? undefined : $event
                        "
                        [disabled]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                        [required]="e['required'] == 1"
                        (selectionChange)="onChange(e, $event)"
                        [compareWith]="compareFn"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                      >
                        <!-- Hidden default option for label fix -->
                        <mat-option value="" style="display: none">
                          {{
                            -(-form.data[e.code])
                              ? ""
                              : "--Select " + e.label + " --"
                          }}
                        </mat-option>

                        <!-- Search input -->
                        <mat-option>
                          <ngx-mat-select-search
                            #searchRef
                            [placeholderLabel]="'Search ' + e.label + '...'"
                            [noEntriesFoundLabel]="'No matches found'"
                          >
                          </ngx-mat-select-search>
                        </mat-option>

                        <!-- Filtered options -->
                        <ng-container
                          *ngFor="
                            let item of getFilteredData(
                              form.preload?.[e.primaryUsecase] || []
                            )
                          "
                        >
                          <mat-option
                            *ngIf="
                              !searchRef.value ||
                              filterFn(searchRef.value, item)
                            "
                            [value]="item.id"
                          >
                            {{ item._val }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- Textarea Field -->
                  <div *ngIf="e['type'] === 'textarea'">
                    <div
                      class="custom-editor-wrapper"
                      *ngIf="e.enableEditor === 1"
                    >
                      <ng-container>
                        <ngx-editor-menu
                          [editor]="editors[e.code]"
                          [toolbar]="toolbar"
                        ></ngx-editor-menu>
                        <ngx-editor
                          [(ngModel)]="form.data[e.code]"
                          [editor]="editors[e.code]"
                          [placeholder]="getFilterLable(e.label)"
                          class="custom-editor"
                        >
                        </ngx-editor>
                      </ng-container>
                    </div>
                    <!-- Else use simple textarea -->
                    <div *ngIf="e.enableEditor !== 1">
                      <mat-form-field appearance="outline" class="w-100">
                        <textarea
                          matInput
                          [placeholder]="getFilterLable(e.label)"
                          [ngModel]="
                            e.enableEditor !== 1
                              ? removeHTMLTags(form.data[e.code])
                              : form.data[e.code]
                          "
                          (ngModelChange)="form.data[e.code] = $event"
                          [id]="e.code"
                          [name]="e.code"
                        >
                        </textarea>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- DropDown List -->
                  <!-- <div *ngIf="e['type'] === 'list'" class="w-100">
                    <div *ngIf="e['listType'] === 'none' || e['listType'] === '' || !e['listType']"
                      class="d-flex align-items-center w-100">
                    
                      <div *ngIf="e['multipleSelect'] == 1" class="position-relative w-100">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select multiple required="{{ e['required'] == 1 }}" [(ngModel)]="form.data[e.code]"
                            [disabled]="e['readOnly'] || (e.allowChangeAfterInitial == 1 && form.data['id'] > 0)"
                            id="{{ e.code }}" name="{{e.code}}" (change)="onChange(e, $event)">
                            <mat-option *ngFor="let c of e['values']" [value]="c">{{ c }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      
                      <mat-form-field *ngIf="e['multipleSelect'] != 1" appearance="outline" class="w-100 mb-3">
                        <mat-select required="{{ e['required'] == 1 }}" [(ngModel)]="form.data[e.code]"
                          [disabled]="e['readOnly'] || (e.allowChangeAfterInitial == 1 && form.data['id'] > 0)"
                          (change)="onChange(e, $event)" id="{{ e.code }}" name="{{e.code}}">
                          <mat-option [value]="undefined" disabled>{{getFilterLable(e.label)}}</mat-option>
                          <mat-option *ngFor="let c of e['values']" [value]="c">{{ c }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div *ngIf="e['listType'] === 'radio'" class="d-flex align-items-center w-100">
                      <mat-radio-group *ngIf="e['showVertical'] === 'horizontal'" [(ngModel)]="form.data[e.code]"
                        name="{{ e.code }}" class="d-flex flex-row">
                        <mat-radio-button *ngFor="let option of e['values']" [value]="option" color="primary"
                          [disabled]="e['readOnly'] || (e.allowChangeAfterInitial == 1 && form.data['id'] > 0)"
                          class="me-3">
                          {{ option }}
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-radio-group *ngIf="e['showVertical'] === 'vertical'" [(ngModel)]="form.data[e.code]"
                        name="{{ e.code }}" class="d-flex flex-column">
                        <mat-radio-button *ngFor="let option of e['values']" [value]="option" color="primary"
                          [disabled]="e['readOnly'] || (e.allowChangeAfterInitial == 1 && form.data['id'] > 0)">
                          {{ option }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div> -->

                  <div *ngIf="e['type'] === 'list'" class="w-100">
                    <div
                      *ngIf="
                        e['listType'] === 'none' ||
                        e['listType'] === '' ||
                        !e['listType']
                      "
                      class="d-flex align-items-center w-100"
                    >
                      <!-- MULTIPLE SELECT -->
                      <div
                        *ngIf="e['multipleSelect'] == 1"
                        class="position-relative w-100"
                      >
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                          <mat-select
                            multiple
                            [required]="e['required'] == 1"
                            [(ngModel)]="form.data[e.code]"
                            [disabled]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                form.data['id'] > 0)
                            "
                            id="{{ e.code }}"
                            name="{{ e.code }}"
                            (change)="onChange(e, $event)"
                          >
                            <!-- Hidden default option for label fix -->
                            <mat-option value="" style="display: none">
                              -- Select {{ getFilterLable(e.label) }} --
                            </mat-option>
                            <mat-option
                              *ngFor="let c of e['values']"
                              [value]="c"
                            >
                              {{ c }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- SINGLE SELECT -->
                      <mat-form-field
                        *ngIf="e['multipleSelect'] != 1"
                        appearance="outline"
                        class="w-100 mb-3"
                      >
                        <mat-select
                          [ngModel]="
                            form.data[e.code] === undefined
                              ? ''
                              : form.data[e.code]
                          "
                          (ngModelChange)="
                            form.data[e.code] =
                              $event === '' ? undefined : $event
                          "
                          [required]="e['required'] == 1"
                          [disabled]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              form.data['id'] > 0)
                          "
                          (change)="onChange(e, $event)"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                        >
                          <!-- Hidden default option for label fix -->
                          <mat-option value="" style="display: none">
                            -- Select {{ getFilterLable(e.label) }} --
                          </mat-option>
                          <mat-option *ngFor="let c of e['values']" [value]="c">
                            {{ c }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- RADIO -->
                    <div
                      *ngIf="e['listType'] === 'radio'"
                      class="d-flex align-items-center w-100"
                    >
                      <!-- HORIZONTAL -->
                      <mat-radio-group
                        *ngIf="e['showVertical'] === 'horizontal'"
                        [(ngModel)]="form.data[e.code]"
                        name="{{ e.code }}"
                        class="d-flex flex-row"
                      >
                        <mat-radio-button
                          *ngFor="let option of e['values']"
                          [value]="option"
                          color="primary"
                          [disabled]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              form.data['id'] > 0)
                          "
                          class="me-3"
                        >
                          {{ option }}
                        </mat-radio-button>
                      </mat-radio-group>

                      <!-- VERTICAL -->
                      <mat-radio-group
                        *ngIf="e['showVertical'] === 'vertical'"
                        [(ngModel)]="form.data[e.code]"
                        name="{{ e.code }}"
                        class="d-flex flex-column"
                      >
                        <mat-radio-button
                          *ngFor="let option of e['values']"
                          [value]="option"
                          color="primary"
                          [disabled]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              form.data['id'] > 0)
                          "
                        >
                          {{ option }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>

                  <!-- File Field -->
                  <div *ngIf="e['type'] === 'file'">
                    <div class="d-flex align-items-center">
                      <mat-form-field appearance="outline" class="w-100">
                        <input
                          matInput
                          readonly
                          placeholder="Upload image here.."
                          [value]="file.files?.[0]?.name || ''"
                          (click)="file.click()"
                          style="cursor: pointer"
                        />
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          class="icon-pd-none"
                          (click)="file.click()"
                        >
                          <mat-icon class="icon-compact text-secondary"
                            >attach_file</mat-icon
                          >
                        </button>
                        <input
                          type="file"
                          #file
                          hidden
                          accept="image/*"
                          [id]="'entryform.data[' + e.code + ']'"
                          [name]="'entryform.data[' + e.code + ']'"
                          (change)="openCropperModal($event, e.code)"
                        />
                      </mat-form-field>
                    </div>
                    <!-- Show error only for the specific field -->
                    <div *ngIf="fileErrors[e.code]" class="text-danger">
                      {{ "USECASEDATABASE.FILE_TYPE_ERROR" | translate }}
                    </div>
                    <div *ngIf="imageSizes[e.code]" class="text-danger">
                      {{
                        "USECASEDATABASE.FILE_SIZE_ERROR"
                          | translate: { size: e.size || 1 }
                      }}
                    </div>
                  </div>

                  <!-- Image Preview -->
                  <div class="mt-4 mb-1" *ngIf="e['type'] === 'file'">
                    <div *ngIf="!fileErrors[e.code] && !imageSizes[e.code]">
                      <a
                        href="{{ getAppDoc(form.data[e.code]) }}"
                        target="_blank"
                      >
                        <img
                          [src]="
                            imagePreviews[e.code]
                              ? imagePreviews[e.code]
                              : getAppDoc(form.data[e.code])
                          "
                          [alt]="'USECASEDATABASE.PREVIEW' | translate"
                          class="img-thumbnail"
                          style="width: 200px"
                        />
                      </a>
                    </div>
                  </div>

                  <!-- Doc File -->
                  <div *ngIf="e['type'] === 'doc'">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        readonly
                        placeholder="Upload doc here.."
                        [value]="filedoc.files?.[0]?.name || ''"
                        (click)="filedoc.click()"
                        style="cursor: pointer"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        class="icon-pd-none"
                        (click)="filedoc.click()"
                        type="button"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >attach_file</mat-icon
                        >
                      </button>
                      <input
                        type="file"
                        #filedoc
                        hidden
                        [id]="'entryform.data[' + e.code + ']'"
                        [name]="'entryform.data[' + e.code + ']'"
                        (change)="
                          filedoc.files &&
                            onFileChanged($event, e, form.data[e.code])
                        "
                      />
                    </mat-form-field>
                    <div *ngIf="docSizes[e.code]" class="text-danger">
                      {{
                        "USECASEDATABASE.FILE_SIZE_ERROR"
                          | translate: { size: e.size || 1 }
                      }}
                    </div>
                    <div *ngIf="docFileErrors[e.code]" class="text-danger">
                      {{ "USECASEDATABASE.DOC_FILE_ERROR" | translate }}
                    </div>
                  </div>

                  <!-- Image Preview Doc Preview -->
                  <div class="mt-4 mb-1" *ngIf="e['type'] === 'doc'">
                    <a
                      href="{{ getAppDoc(form.data[e.code]) }}"
                      target="_blank"
                    >
                      <img
                        [src]="
                          imagePreview == null
                            ? getAppDocThumbnail(form.data[e.code])
                            : imagePreview
                        "
                        [alt]="'USECASEDATABASE.PREVIEW' | translate"
                        class="img-thumbnail"
                        style="width: 200px"
                      />
                    </a>
                  </div>

                  <!-- Map Field -->
                  <!-- <div *ngIf="e['type']==='map'">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-select required="{{ e['required'] == 1 }}" [(ngModel)]="form.data[e.code]"
                        [disabled]="e['readOnly'] || (e.allowChangeAfterInitial == 1 && form.data['id'] > 0)"
                        (change)="onChange(e, $event)" id="{{ e.code }}" name="{{ e.code }}">
                        <mat-option [value]="undefined" disabled>{{getFilterLable(e.label)}}</mat-option>
                        <mat-option *ngFor="let c of e['values']" value="{{ c.key }} - {{ c.value }}">
                          {{ c.key }} - {{ c.value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div> -->

                  <div *ngIf="e['type'] === 'map'">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-select
                        [ngModel]="
                          form.data[e.code] === undefined
                            ? ''
                            : form.data[e.code]
                        "
                        (ngModelChange)="
                          form.data[e.code] = $event === '' ? undefined : $event
                        "
                        [required]="e['required'] == 1"
                        [disabled]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            form.data['id'] > 0)
                        "
                        (change)="onChange(e, $event)"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                      >
                        <!-- Hidden default option for label fix -->
                        <mat-option value="" style="display: none">
                          -- Select {{ getFilterLable(e.label) }} --
                        </mat-option>

                        <mat-option
                          *ngFor="let c of e['values']"
                          value="{{ c.key }} - {{ c.value }}"
                        >
                          {{ c.key }} - {{ c.value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- Location Field Block -->
                  <div *ngIf="e['type'] === 'location'">
                    <div class="d-flex align-items-center">
                      <!-- Latitude -->
                      <ng-container
                        *ngIf="
                          form.data[e.code]?.lat != null &&
                          form.data[e.code]?.lng != null
                        "
                      >
                        <mat-form-field
                          appearance="outline"
                          class="me-2 flex-grow-1 mb-1"
                        >
                          <mat-label>{{
                            "UsecaseData.FORM.LATITUDE" | translate
                          }}</mat-label>
                          <input
                            matInput
                            type="number"
                            readonly
                            [(ngModel)]="form.data[e.code].lat"
                            name="{{ e.code + '_lat' }}"
                            [placeholder]="'LATITUDE' | translate"
                          />
                        </mat-form-field>
                        <mat-form-field
                          appearance="outline"
                          class="me-2 flex-grow-1 mb-1"
                        >
                          <mat-label>{{
                            "UsecaseData.FORM.LONGITUDE" | translate
                          }}</mat-label>
                          <input
                            matInput
                            type="number"
                            readonly
                            [(ngModel)]="form.data[e.code].lng"
                            name="{{ e.code + '_lng' }}"
                            [placeholder]="'LONGITUDE' | translate"
                          />
                        </mat-form-field>
                      </ng-container>
                      <!-- Show this block if lat/lng is null -->
                      <ng-template #emptyInputs>
                        <mat-form-field
                          appearance="outline"
                          class="me-2 flex-grow-1 mb-1"
                        >
                          <input
                            matInput
                            readonly
                            [value]="'USECASEDATABASE.NO_LOCATION' | translate"
                            name="{{ e.code + '_lat_placeholder' }}"
                            [placeholder]="'LATITUDE' | translate"
                          />
                        </mat-form-field>
                        <mat-form-field
                          appearance="outline"
                          class="me-2 flex-grow-1 mb-1"
                        >
                          <input
                            matInput
                            readonly
                            [value]="'USECASEDATABASE.NO_LOCATION' | translate"
                            name="{{ e.code + '_lng_placeholder' }}"
                            [placeholder]="'LONGITUDE' | translate"
                          />
                        </mat-form-field>
                      </ng-template>

                      <!-- Set current location -->
                      <button
                        mat-stroked-button
                        [title]="'USECASEDATABASE.LOCATION' | translate"
                        type="button"
                        color="warn"
                        class="me-2 icon-width"
                        (click)="setCurrentLocation(e.code)"
                      >
                        <mat-icon class="icon-compact">location_on</mat-icon>
                      </button>
                      <!-- View on map -->
                      <button
                        mat-stroked-button
                        [title]="'USECASEDATABASE.VIEW_ON_MAP' | translate"
                        type="button"
                        color="primary"
                        class="me-2 icon-width"
                        (click)="viewOnMap(e.code)"
                      >
                        <mat-icon class="icon-compact">map</mat-icon>
                      </button>
                      <!-- Clear location -->
                      <button
                        mat-stroked-button
                        [title]="'USECASEDATABASE.CLEAR_LOCATION' | translate"
                        type="button"
                        color="warn"
                        class="me-2 icon-width"
                        (click)="clearLocation(e.code)"
                      >
                        <i
                          class="fa fa-eraser icon-compact d-inline-block"
                          style="font-size: 16px !important"
                        ></i>
                      </button>
                    </div>
                  </div>
                  <p class="form-text text-danger pt-0 mt-0 pb-2 ms-2">
                    {{ getInputError(e.code) }}
                  </p>
                </div>
              </form>
              <!-- db form end -->
            </div>
            <div class="card-footer bg-white py-3">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                [disabled]="!usecaseForm.valid"
                (click)="saveUsecaseData()"
                [matTooltip]="'USECASEDATABASE.SAVE' | translate"
              >
                <mat-icon class="me-1">save</mat-icon>
                {{ "USECASEDATABASE.SAVE" | translate }}
              </button>

              <button
                mat-stroked-button
                color="primary"
                type="button"
                class="ms-2"
                (click)="resetForm(); resetHtmlData(); setDefaultvalue()"
                [matTooltip]="'USECASEDATABASE.ADD' | translate"
              >
                <mat-icon class="me-1">add</mat-icon>
                {{ "USECASEDATABASE.ADD_NEW" | translate }}
              </button>
            </div>
          </div>
          <!-- Comment Section -->
          <div
            class="col-12"
            *ngIf="usecaseSchema?.commentEnabled == 1 && form['data']['id'] > 0"
          >
            <div class="card">
              <!-- Card Header -->
              <div class="card-header p-3 bg-white">
                <div
                  class="card-title m-0 d-flex align-items-center justify-content-between"
                >
                  <h6>
                    {{ "USECASEDATABASE.COMMENTS" | translate }}
                  </h6>

                  <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    class="icon-width"
                    data-bs-target="#commentModel"
                    data-bs-toggle="modal"
                  >
                    <mat-icon class="me-1">add</mat-icon>
                    Comment
                  </button>
                </div>
              </div>

              <!-- Card Body -->
              <div class="card-body">
                <div class="table-responsive">
                  <!-- Success/Error Message -->
                  <!-- <p *ngIf="form['searchError'] == false && form['searchMessage']" class="m-0">
                                      <app-ncs-alert [message]="form['searchMessage']" type="success"></app-ncs-alert>
                                      </p>
                                      <p *ngIf="form['searchError'] == true && form['searchMessage']" class="m-0">
                                      <app-ncs-alert [message]="form['searchMessage']" type="danger"></app-ncs-alert>
                                      </p> -->
                  <!-- Table -->

                  <div class="table-container">
                    <div class="table-responsive">
                      <div style="max-height: 400px; overflow-y: auto">
                        <table class="table table-bordered table-hover">
                          <thead>
                            <tr>
                              <th class="text-center">#</th>
                              <th style="width: 60%">Comment</th>
                              <th>User & Date</th>
                              <th class="text-center">ACTION</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr
                              *ngFor="let e of commentList; let i = index"
                              class="align-middle border-bottom"
                            >
                              <td class="py-2 px-2 text-center">
                                {{ pageIndex(i) }}
                              </td>
                              <td style="width: 60%">
                                {{ e.comment }}
                              </td>
                              <td>
                                <div class="d-flex align-items-center gap-2">
                                  <div
                                    class="notify bg-light-primary text-primary rounded-circle d-flex align-items-center justify-content-center"
                                    style="
                                      width: 32px;
                                      height: 32px;
                                      font-size: 12px;
                                      font-weight: 600;
                                      border: 1px solid #ddd;
                                    "
                                  >
                                    <span [matTooltip]="e.userFirstname">{{
                                      getInitials(e.userFirstname)
                                    }}</span>
                                  </div>
                                  <span>
                                    {{ e.createdDatetime | date: "MMM d, y" }}
                                  </span>
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="d-flex gap-2">
                                  <button
                                    mat-stroked-button
                                    type="button"
                                    color="primary"
                                    class="icon-width"
                                    [matTooltip]="
                                      'USECASEDATABASE.INFORMATION' | translate
                                    "
                                    data-bs-toggle="modal"
                                    data-bs-target="#appCommentInfo"
                                    (click)="appCommentInfo = e"
                                  >
                                    <mat-icon class="icon-compact"
                                      >info</mat-icon
                                    >
                                  </button>

                                  <button
                                    mat-stroked-button
                                    type="button"
                                    color="primary"
                                    class="icon-width"
                                    [matTooltip]="
                                      'USECASEDATABASE.EDIT' | translate
                                    "
                                    data-bs-toggle="modal"
                                    data-bs-target="#commentModel"
                                    (click)="getComment(e.id)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >edit</mat-icon
                                    >
                                  </button>

                                  <button
                                    mat-stroked-button
                                    type="button"
                                    color="warn"
                                    class="icon-width"
                                    [matTooltip]="
                                      'USECASEDATABASE.DELETE' | translate
                                    "
                                    (click)="deleteComment(e.id)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >delete</mat-icon
                                    >
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Attachment Section -->
          <div
            class="col-12"
            *ngIf="
              usecaseSchema?.attachmentEnabled == 1 && form['data']['id'] > 0
            "
          >
            <div class="card">
              <div class="card-header p-3 bg-white">
                <div
                  class="card-title m-0 d-flex align-items-center justify-content-between"
                >
                  <h6>
                    {{ "USECASEDATABASE.ATTACHMENTS" | translate }}
                  </h6>

                  <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    class="icon-width"
                    data-bs-target="#attachmentModel"
                    data-bs-toggle="modal"
                  >
                    <mat-icon class="icon-compact">add</mat-icon>
                    Attachment
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <!-- Success/Error Message -->
                  <!-- <p *ngIf="form['searchError'] == false && form['searchMessage']">
                                          <app-ncs-alert [message]="form['searchMessage']" type="success"></app-ncs-alert>
                                          </p>
                                          <p *ngIf="form['searchError'] ==  true && form['searchMessage']">
                                          <app-ncs-alert [message]="form['searchMessage']" type="danger"></app-ncs-alert>
                                          </p> -->

                  <div class="table-container">
                    <div class="table-responsive">
                      <div style="max-height: 400px; overflow-y: auto">
                        <table
                          class="table table-bordered table-hover align-middle"
                        >
                          <thead class="bg-light">
                            <tr>
                              <th>#</th>
                              <th>PREVIEW</th>
                              <th style="width: 60%">DESCRIPTION</th>
                              <th>User & Date</th>
                              <th class="text-center">ACTION</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr
                              *ngFor="let e of attachmentList; let i = index"
                              class="border-bottom"
                            >
                              <td
                                class="text-center"
                                style="
                                  width: 5%;
                                  font-size: 0.85rem;
                                  color: #555;
                                "
                              >
                                {{ pageIndex(i) }}
                              </td>

                              <td class="text-center">
                                <a
                                  [href]="getAppDoc(e.attachment)"
                                  target="_blank"
                                >
                                  <div class="image-preview">
                                    <img
                                      [src]="getAppDocThumbnail(e.attachment)"
                                      class="img-fluid"
                                    />
                                  </div>
                                </a>
                              </td>

                              <td style="width: 60%">
                                <div
                                  class="d-flex align-items-center justify-content-start gap-2"
                                >
                                  {{ e.description | truncate: 80 }}
                                </div>
                              </td>

                              <td>
                                <div
                                  class="d-flex align-items-center justify-content-start gap-2"
                                >
                                  <div
                                    class="notify bg-light-primary text-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                    style="
                                      width: 32px;
                                      height: 32px;
                                      font-size: 12px;
                                      font-weight: 600;
                                      border: 1px solid #ddd;
                                    "
                                  >
                                    <span [matTooltip]="e.userFirstname">{{
                                      getInitials(e.userFirstname)
                                    }}</span>
                                  </div>
                                  <span>
                                    {{ e.createdDatetime | date: "MMM d, y" }}
                                  </span>
                                </div>
                              </td>

                              <td class="text-center">
                                <div
                                  class="d-flex gap-2 justify-content-center"
                                >
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    [matTooltip]="
                                      'USECASEDATABASE.INFORMATION' | translate
                                    "
                                    class="icon-width"
                                    data-bs-toggle="modal"
                                    data-bs-target="#appAttachmentInfo"
                                    (click)="appAttachmentInfo = e"
                                  >
                                    <mat-icon class="icon-compact"
                                      >info</mat-icon
                                    >
                                  </button>

                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    class="icon-width"
                                    [matTooltip]="
                                      'USECASEDATABASE.EDIT' | translate
                                    "
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#attachmentModel"
                                    (click)="getattachment(e.id)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >edit</mat-icon
                                    >
                                  </button>

                                  <button
                                    mat-stroked-button
                                    color="warn"
                                    class="icon-width"
                                    [matTooltip]="
                                      'USECASEDATABASE.DELETE' | translate
                                    "
                                    (click)="deleteattachment(e.id)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >delete</mat-icon
                                    >
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="usecase-chart"
          role="tabpanel"
          aria-labelledby="usecase-chart-tab"
        >
          <!-- chart  -->
          <app-usecase-chart
            *ngIf="activetab == 'usecase-chart-tab'"
            [usecaseId]="usecaseId"
          >
          </app-usecase-chart>
        </div>
        <div
          class="tab-pane fade"
          id="usecase-chart-custom"
          role="tabpanel"
          aria-labelledby="usecase-chart-cutom-tab"
        >
          <!-- chart-custom -->
          <app-usecase-chart
            *ngIf="activetab == 'usecase-chart-custom-tab'"
            [usecaseId]="usecaseId"
            [custom]="true"
          ></app-usecase-chart>
        </div>
        <div
          class="tab-pane fade"
          id="usecase-pivot"
          role="tabpanel"
          aria-labelledby="usecase-pivot-cutom-tab"
        >
          <!-- pivot  -->
          <app-usecase-pivot
            *ngIf="activetab == 'usecase-pivot-tab'"
            [usecaseId]="usecaseId"
          ></app-usecase-pivot>
        </div>
        <div
          class="tab-pane fade"
          id="usecase-help"
          role="tabpanel"
          aria-labelledby="usecase-help-tab"
        >
          <div *ngIf="activetab == 'usecase-help-tab'" class="col-11">
            <div class="row">
              <div class="col col-md-12">
                <h5>
                  <i
                    class="fa fa-info-circle text-primary"
                    aria-hidden="true"
                  ></i>
                  {{ usecaseSchema["name"] }} >
                  {{ "USECASEDATABASE.INFORMATION" | translate }}
                </h5>
              </div>
              <div class="col col-md-12 mt-3">
                <div class="card">
                  <div class="card-header">
                    <p class="text-muted">{{ usecaseSchema["description"] }}</p>
                  </div>
                  <div class="card-body">
                    <div *ngFor="let e of attributeList; let i = index">
                      <ng-container>
                        <h6>{{ e.label }}</h6>
                        <p>{{ e.description }}</p>
                      </ng-container>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="usecase-task"
          role="tabpanel"
          aria-labelledby="usecase-task-tab"
        >
          <!-- task  -->
        </div>
        <div
          class="tab-pane fade"
          id="usecase-new"
          role="tabpanel"
          aria-labelledby="usecase-new-tab"
        >
          <!-- new  -->
        </div>
        <div
          class="tab-pane fade"
          id="usecase-settings"
          role="tabpanel"
          aria-labelledby="usecase-settings-tab"
        >
          <!-- settings  -->
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="infoModal"
  tabindex="-1"
  aria-labelledby="infoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Information</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <!-- <app-info-button [ele]="e"></app-info-button> -->
        <div [innerHTML]="tooltipContent"></div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{'USECASEDATABASE.CLOSE' |
          translate}}</button> -->
        <button
          mat-stroked-button
          type="button"
          data-bs-dismiss="modal"
          color="warn"
        >
          <mat-icon>close</mat-icon>
          <span>{{ "USECASEDATABASE.CLOSE" | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!--Comment Modal -->
<div
  class="modal fade"
  id="commentModel"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="commentModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="commentModelLabel">
          {{ "USECASEDATABASE.COMMENTS" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="resetcommentForm()"
        ></button>
      </div>
      <div class="modal-body compact-inputs dropdown-pd-none">
        <p *ngIf="sform['error'] == false && sform['message']">
          <app-ncs-alert [message]="sform['message']" type="success" />
        </p>
        <p *ngIf="sform['error'] == true && sform['message']">
          <app-ncs-alert [message]="sform['message']" type="danger" />
        </p>
        <mat-form-field appearance="outline" class="w-100">
          <textarea
            matInput
            required
            name="comment"
            id="comment"
            [(ngModel)]="commentform.data['comment']"
          >
          </textarea>
        </mat-form-field>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          type="button"
          (click)="resetcommentForm()"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "USECASEDATABASE.CLOSE" | translate }}
        </button>

        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="addPageComment()"
          [disabled]="!commentform.data['comment']"
        >
          <mat-icon>save</mat-icon>
          {{ "USECASEDATABASE.SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!--Attachment Modal -->
<div
  class="modal fade"
  id="attachmentModel"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="attachmentModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="attachmentModelLabel">
          {{ "UsecaseData.MODAL.ATTACHMENT.TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'BUTTONS.CLOSE' | translate"
          (click)="resetattachmentForm()"
        ></button>
      </div>
      <div class="modal-body compact-inputs dropdown-pd-none">
        <div class="mb-3">
          <label for="attachment" class="form-label"
            >{{ "UsecaseData.FORM.DESCRIPTION" | translate }}
          </label>
          <mat-form-field appearance="outline" class="w-100 dropdown-pd-none">
            <textarea
              matInput
              name="description"
              id="description"
              rows="3"
              [(ngModel)]="attachmentform.data['description']"
              [placeholder]="
                'MODAL.ATTACHMENT.DESCRIPTION_PLACEHOLDER' | translate
              "
            >
            </textarea>
          </mat-form-field>
        </div>
        <div class="mb-4">
          <label for="attachment" class="form-label"
            >{{ "UsecaseData.MODAL.ATTACHMENT.ATTACHMENT_LABEL" | translate }}
            <span class="text-danger">*</span>
          </label>
          <div class="d-flex align-items-center">
            <!-- <input required class="form-control form-control-sm" id="attachment" #fileAttechment type="file"
              name="attachment" [(ngModel)]="attachmentform.data['attachment']"
              (change)="fileAttechment.files && onAttachmentformChanged($event)" /> -->
            <!-- Angular Material version with styled file input -->
            <mat-form-field appearance="outline" class="w-100">
              <input
                (click)="fileAttechment.click()"
                matInput
                readonly
                placeholder="Choose file"
                [value]="fileAttechment?.files?.[0]?.name || ''"
                style="cursor: pointer"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="fileAttechment.click()"
                class="icon-pd-none"
                aria-label=" Browse files"
              >
                <mat-icon class="compact-icon text-secondary"
                  >attach_file</mat-icon
                >
              </button>
              <input
                #fileAttechment
                type="file"
                hidden
                id="attachment"
                name="attachment"
                [(ngModel)]="attachmentform.data['attachment']"
                (change)="
                  fileAttechment.files && onAttachmentformChanged($event)
                "
              />
            </mat-form-field>
          </div>
        </div>
        <div class="mb-4">
          <label class="form-label d-block fw-bold mb-3">
            {{ "UsecaseData.MODAL.ATTACHMENT.PREVIEW" | translate }}
          </label>
          <div class="preview-container">
            <img
              [src]="
                imageAttachmentPreview
                  ? imageAttachmentPreview
                  : getAppDocThumbnail(attachmentform.data['attachment'])
              "
              [alt]="'UsecaseData.MODAL.ATTACHMENT.PREVIEW_ALT' | translate"
              class="img-thumbnail mat-elevation-z2"
              style="max-width: 200px; max-height: 200px; border-radius: 4px"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          type="button"
          (click)="resetattachmentForm()"
          data-bs-dismiss="modal"
          class="me-2"
        >
          <mat-icon>close</mat-icon>
          {{ "UsecaseData.BUTTONS.CLOSE" | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          [disabled]="
            attachmentform.data['attachment'] == null &&
            imageAttachmentPreview == null
          "
          (click)="saveAttachment()"
        >
          <mat-icon>save</mat-icon>
          {{ "UsecaseData.BUTTONS.SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!--Attachment Info Modal -->
<div class="modal fade" id="appAttachmentInfo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "UsecaseData.MODAL.ATTACHMENT_INFO.TITLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'BUTTONS.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div class="table-container">
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th scope="col">{{ "UsecaseData.TABLE.KEY" | translate }}</th>
                  <th scope="col">
                    {{ "UsecaseData.TABLE.VALUE" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.ATTACHMENT_INFO.ORGANIZATION"
                        | translate
                    }}
                  </td>
                  <td>{{ appAttachmentInfo?.["orgName"] }}</td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.ATTACHMENT_INFO.VERSION" | translate
                    }}
                  </td>
                  <td>{{ appAttachmentInfo?.version }}</td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.ATTACHMENT_INFO.CREATED_BY" | translate
                    }}
                  </td>
                  <td>{{ appAttachmentInfo?.createdBy }}</td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.ATTACHMENT_INFO.CREATED_DATE"
                        | translate
                    }}
                  </td>
                  <td>
                    {{
                      appAttachmentInfo?.createdDatetime
                        | date: "MMM d, y, h:mm:ss a"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.ATTACHMENT_INFO.MODIFIED_BY"
                        | translate
                    }}
                  </td>
                  <td>{{ appAttachmentInfo?.modifiedBy }}</td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.ATTACHMENT_INFO.MODIFIED_DATE"
                        | translate
                    }}
                  </td>
                  <td>
                    {{
                      appAttachmentInfo?.modifiedDatetime
                        | date: "MMM d, y, h:mm:ss a"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          type="button"
          [attr.aria-label]="'BUTTONS.CLOSE' | translate"
          data-bs-dismiss="modal"
          class="me-2"
        >
          <mat-icon>close</mat-icon>
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!--Comment Info Modal -->
<div class="modal fade" id="appCommentInfo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ "UsecaseData.MODAL.COMMENT_INFO.TITLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'BUTTONS.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div class="table-container">
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th scope="col">{{ "UsecaseData.TABLE.KEY" | translate }}</th>
                  <th scope="col">
                    {{ "UsecaseData.TABLE.VALUE" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.COMMENT_INFO.ORGANIZATION" | translate
                    }}
                  </td>
                  <td>{{ appCommentInfo?.["orgName"] }}</td>
                </tr>
                <tr>
                  <td>
                    {{ "UsecaseData.MODAL.COMMENT_INFO.VERSION" | translate }}
                  </td>
                  <td>{{ appCommentInfo?.version }}</td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.COMMENT_INFO.CREATED_BY" | translate
                    }}
                  </td>
                  <td>{{ appCommentInfo?.createdBy }}</td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.COMMENT_INFO.CREATED_DATE" | translate
                    }}
                  </td>
                  <td>
                    {{
                      appCommentInfo?.createdDatetime
                        | date: "MMM d, y, h:mm:ss a"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.COMMENT_INFO.MODIFIED_BY" | translate
                    }}
                  </td>
                  <td>{{ appCommentInfo?.modifiedBy }}</td>
                </tr>
                <tr>
                  <td>
                    {{
                      "UsecaseData.MODAL.COMMENT_INFO.MODIFIED_DATE" | translate
                    }}
                  </td>
                  <td>
                    {{
                      appCommentInfo?.modifiedDatetime
                        | date: "MMM d, y, h:mm:ss a"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          type="button"
          data-bs-dismiss="modal"
          [attr.aria-label]="'BUTTONS.CLOSE' | translate"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!--  Image Update Model  -->
<!-- Image Cropper Modal -->
<div
  class="modal fade"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  id="imageModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Crop Image</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="cancelCrop()"
        ></button>
      </div>

      <div class="button-row my-3 ms-2" *ngIf="showCropper">
        <button
          mat-stroked-button
          color="primary"
          (click)="zoomIn()"
          [class.enabled]="transform.flipV"
          class="me-2"
          [matTooltip]="'PROFILE.ZOOM_IN' | translate"
        >
          <mat-icon>zoom_in</mat-icon> {{ "PROFILE.ZOOM_IN" | translate }}
        </button>

        <button
          mat-stroked-button
          color="primary"
          (click)="zoomOut()"
          [class.enabled]="transform.flipV"
          class="me-1"
          [matTooltip]="'PROFILE.ZOOM_OUT' | translate"
        >
          <mat-icon>zoom_out</mat-icon> {{ "PROFILE.ZOOM_OUT" | translate }}
        </button>

        <button
          mat-stroked-button
          color="primary"
          (click)="rotateRight()"
          [class.enabled]="transform.flipV"
          class="me-1"
          [matTooltip]="'PROFILE.ROTATE_RIGHT' | translate"
        >
          <mat-icon>rotate_right</mat-icon>
          {{ "PROFILE.ROTATE_RIGHT" | translate }}
        </button>

        <button
          mat-stroked-button
          color="primary"
          (click)="rotateLeft()"
          [class.enabled]="transform.flipV"
          class="me-1"
          [matTooltip]="'PROFILE.ROTATE_LEFT' | translate"
        >
          <mat-icon>rotate_left</mat-icon>
          {{ "PROFILE.ROTATE_LEFT" | translate }}
        </button>

        <button
          mat-stroked-button
          color="primary"
          (click)="flipHorizontal()"
          [class.enabled]="transform.flipH"
          class="me-1"
          [matTooltip]="'PROFILE.FLIP_HORIZONTAL' | translate"
        >
          <mat-icon>flip</mat-icon> {{ "PROFILE.FLIP_HORIZONTAL" | translate }}
        </button>

        <button
          mat-stroked-button
          color="primary"
          (click)="flipVertical()"
          [class.enabled]="transform.flipV"
          class="me-1"
          [matTooltip]="'PROFILE.FLIP_VERTICAL' | translate"
        >
          <mat-icon>flip</mat-icon> {{ "PROFILE.FLIP_VERTICAL" | translate }}
        </button>
      </div>
      <div class="modal-body">
        <div class="w-100">
          <div class="cropper-wrapper">
            <image-cropper
              [disabled]="disabled"
              [alignImage]="alignImage"
              [roundCropper]="roundCropper"
              [hidden]="hidden"
              [imageChangedEvent]="imageChangedEvent"
              [hideResizeSquares]="hideResizeSquares"
              [maintainAspectRatio]="false"
              [canvasRotation]="canvasRotation"
              [containWithinAspectRatio]="false"
              [(transform)]="transform"
              [aspectRatio]="aspectRatio"
              format="png"
              [cropperStaticWidth]="cropperStaticWidth"
              [cropperStaticHeight]="cropperStaticHeight"
              [cropperMinWidth]="cropperMinWidth"
              [cropperMinHeight]="cropperMinHeight"
              [cropperMaxWidth]="cropperMaxWidth"
              [cropperMaxHeight]="cropperMaxHeight"
              [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
              [onlyScaleDown]="true"
              [style.width.%]="100"
              [style.height.%]="100"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded()"
              (cropperReady)="cropperReady($event)"
              (loadImageFailed)="loadImageFailed()"
            >
            </image-cropper>
          </div>
        </div>
        <div *ngIf="croppedImage" class="mt-3">
          <h6 class="fw-bold">Preview</h6>
          <div class="text-center">
            <img
              [src]="croppedImage"
              alt="Cropped Preview"
              class="img-thumbnail"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-outline-primary btn-sm ml-2" [disabled]="!croppedImage"
          (click)="saveCroppedImage()" data-bs-dismiss="modal"> <i class="fa fa-save"></i> {{ 'COMMON.SAVE' | translate
          }}</button>
        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal"
          (click)="cancelCrop()"><i class="fa fa-window-close"></i> {{ 'COMMON.CLOSE' | translate }}</button> -->
        <button
          mat-stroked-button
          color="primary"
          type="button"
          class="me-2"
          [disabled]="!croppedImage"
          (click)="saveCroppedImage()"
          data-bs-dismiss="modal"
        >
          <mat-icon>save</mat-icon> {{ "COMMON.SAVE" | translate }}
        </button>

        <button
          mat-stroked-button
          color="warn"
          type="button"
          class="me-2"
          data-bs-dismiss="modal"
          (click)="cancelCrop()"
        >
          <mat-icon>close</mat-icon> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Upload Summary Modal - Theme Matched -->
<div
  class="modal fade"
  id="uploadSummaryModal"
  tabindex="-1"
  aria-labelledby="uploadSummaryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="h6 modal-title" id="uploadSummaryModalLabel">
          {{
            uploadResult.errorRows === 0
              ? "Upload Completed Successfully"
              : "Upload Completed"
          }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="upload-summary-container ms-3">
          <div class="table-responsive">
            <table class="table table-sm align-middle table-bordered mb-0">
              <tbody>
                <tr>
                  <th style="width: 70%" class="fw-normal">Total Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.totalRows }}
                  </td>
                </tr>

                <tr>
                  <th style="width: 70%" class="fw-normal">Success Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.successRows }}
                  </td>
                </tr>

                <tr>
                  <th style="width: 70%" class="fw-normal">Error Rows</th>
                  <td class="text-center fw-normal">
                    {{ uploadResult.errorRows }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="warn"
          *ngIf="uploadResult.errorRows > 0"
          (click)="viewErrorDetails()"
          [title]="'View Error Details'"
        >
          <mat-icon>list</mat-icon>
          View Errors
        </button>
        <button
          type="button"
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          [title]="'BUTTONS.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  id="tagsModal"
  class="modal fade compact-inputs dropdown-pd-none"
  tabindex="-1"
  aria-labelledby="tagsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="tagsModalLabel">
          <i class="bi bi-tags me-2"></i>{{ "Tag.TAG" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="mb-4">
          <label class="form-label fw-semibold mb-2 d-block">{{
            "Tag.ADD_TAG" | translate
          }}</label>
          <div class="d-flex flex-sm-nowrap flex-wrap align-items-center gap-1">
            <mat-form-field appearance="outline" class="w-100">
              <input
                #tagInput
                matInput
                type="text"
                (input)="onUserInput($event)"
                [(ngModel)]="inputValue"
                placeholder="{{ 'Tag.TAG_PLACE' | translate }}"
              />
            </mat-form-field>
            <button
              mat-stroked-button
              type="button"
              color="primary"
              class="icon-center icon-width"
              (click)="saveTags()"
              matTooltip="{{ 'Tag.ADD_TAGS' | translate }}"
              matTooltipPosition="above"
            >
              <mat-icon>add</mat-icon>
              <span>{{ "Tag.ADD" | translate }}</span>
            </button>
            <button
              mat-stroked-button
              type="button"
              class="icon-center icon-width"
              (click)="resetTagInput(tagInput)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <span class="d-flex align-items-center mt-1">
            <i class="bi bi-info-circle text-muted me-2"></i>
            <small>{{ "Tag.TAG_INFO" | translate }}</small>
          </span>
        </div>
        <div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="form-label fw-semibold mb-0">{{
              "Tag.Available_Tags" | translate
            }}</label>
            <span class="badge bg-secondary"
              >{{ filteredTagsList.length }} {{ "Tag.TAG" | translate }}</span
            >
          </div>
          <div
            class="border rounded p-2"
            style="max-height: 250px; overflow-y: auto"
          >
            <div
              class="form-check mb-2"
              *ngFor="let tag of filteredTagsList; let i = index"
            >
              <div class="d-flex align-items-center">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  [id]="'tagCheckbox' + i"
                  [checked]="selectedTags.includes(tag)"
                  (change)="onTagCheckboxChange(tag, $event)"
                />
                <label
                  class="form-check-label flex-grow-1"
                  [for]="'tagCheckbox' + i"
                >
                  <span
                    class="badge bg-light text-dark border px-3 py-2 w-100 text-start"
                  >
                    <i class="bi bi-tag-fill text-primary me-2"></i>
                    {{ tag }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "Tag.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
